(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired472"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired472"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6ObR8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4f509bf21ce2142e$export$ffb0004e005737fa; }, function (v) { return $4f509bf21ce2142e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4f509bf21ce2142e$export$34b9dba7ce09269b; }, function (v) { return $4f509bf21ce2142e$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4f509bf21ce2142e$export$25062201e9e25d76; }, function (v) { return $4f509bf21ce2142e$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4f509bf21ce2142e$export$ffb0004e005737fa;
var $4f509bf21ce2142e$export$34b9dba7ce09269b;
var $4f509bf21ce2142e$export$25062201e9e25d76;
"use strict";

var $exYeM = parcelRequire("exYeM");
var $4f509bf21ce2142e$var$k = Symbol.for("react.element"), $4f509bf21ce2142e$var$l = Symbol.for("react.fragment"), $4f509bf21ce2142e$var$m = Object.prototype.hasOwnProperty, $4f509bf21ce2142e$var$n = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4f509bf21ce2142e$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4f509bf21ce2142e$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4f509bf21ce2142e$var$m.call(a, b) && !$4f509bf21ce2142e$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4f509bf21ce2142e$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4f509bf21ce2142e$var$n.current
    };
}
$4f509bf21ce2142e$export$ffb0004e005737fa = $4f509bf21ce2142e$var$l;
$4f509bf21ce2142e$export$34b9dba7ce09269b = $4f509bf21ce2142e$var$q;
$4f509bf21ce2142e$export$25062201e9e25d76 = $4f509bf21ce2142e$var$q;

});
parcelRegister("exYeM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bzfnW"));

});
parcelRegister("bzfnW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $86bee5c140ae1e47$export$dca3b0875bd9a954; }, function (v) { return $86bee5c140ae1e47$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $86bee5c140ae1e47$export$16fa2f45be04daa8; }, function (v) { return $86bee5c140ae1e47$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $86bee5c140ae1e47$export$ffb0004e005737fa; }, function (v) { return $86bee5c140ae1e47$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $86bee5c140ae1e47$export$e2c29f18771995cb; }, function (v) { return $86bee5c140ae1e47$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $86bee5c140ae1e47$export$221d75b3f55bb0bd; }, function (v) { return $86bee5c140ae1e47$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $86bee5c140ae1e47$export$5f8d39834fd61797; }, function (v) { return $86bee5c140ae1e47$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $86bee5c140ae1e47$export$74bf444e3cd11ea5; }, function (v) { return $86bee5c140ae1e47$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $86bee5c140ae1e47$export$ae55be85d98224ed; }, function (v) { return $86bee5c140ae1e47$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $86bee5c140ae1e47$export$e530037191fcd5d7; }, function (v) { return $86bee5c140ae1e47$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $86bee5c140ae1e47$export$fd42f52fd3ae1109; }, function (v) { return $86bee5c140ae1e47$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $86bee5c140ae1e47$export$c8a8987d4410bf2d; }, function (v) { return $86bee5c140ae1e47$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $86bee5c140ae1e47$export$d38cd72104c1f0e9; }, function (v) { return $86bee5c140ae1e47$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43; }, function (v) { return $86bee5c140ae1e47$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $86bee5c140ae1e47$export$257a8862b851cb5b; }, function (v) { return $86bee5c140ae1e47$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $86bee5c140ae1e47$export$a8257692ac88316c; }, function (v) { return $86bee5c140ae1e47$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $86bee5c140ae1e47$export$488013bae63b21da; }, function (v) { return $86bee5c140ae1e47$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $86bee5c140ae1e47$export$7c73462e0d25e514; }, function (v) { return $86bee5c140ae1e47$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $86bee5c140ae1e47$export$7568632d0d33d16d; }, function (v) { return $86bee5c140ae1e47$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $86bee5c140ae1e47$export$88948ce120ea2619; }, function (v) { return $86bee5c140ae1e47$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $86bee5c140ae1e47$export$35808ee640e87ca7; }, function (v) { return $86bee5c140ae1e47$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $86bee5c140ae1e47$export$fae74005e78b1a27; }, function (v) { return $86bee5c140ae1e47$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e; }, function (v) { return $86bee5c140ae1e47$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf; }, function (v) { return $86bee5c140ae1e47$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $86bee5c140ae1e47$export$6d9c69b0de29b591; }, function (v) { return $86bee5c140ae1e47$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $86bee5c140ae1e47$export$f680877a34711e37; }, function (v) { return $86bee5c140ae1e47$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $86bee5c140ae1e47$export$d5a552a76deda3c2; }, function (v) { return $86bee5c140ae1e47$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $86bee5c140ae1e47$export$aaabe4eda9ed9969; }, function (v) { return $86bee5c140ae1e47$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $86bee5c140ae1e47$export$e5c5a5f917a5871c; }, function (v) { return $86bee5c140ae1e47$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $86bee5c140ae1e47$export$1538c33de8887b59; }, function (v) { return $86bee5c140ae1e47$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $86bee5c140ae1e47$export$13e3392192263954; }, function (v) { return $86bee5c140ae1e47$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $86bee5c140ae1e47$export$b8f5890fc79d6aca; }, function (v) { return $86bee5c140ae1e47$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $86bee5c140ae1e47$export$60241385465d0a34; }, function (v) { return $86bee5c140ae1e47$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $86bee5c140ae1e47$export$306c0aa65ff9ec16; }, function (v) { return $86bee5c140ae1e47$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $86bee5c140ae1e47$export$7b286972b8d8ccbf; }, function (v) { return $86bee5c140ae1e47$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $86bee5c140ae1e47$export$83d89fbfd8236492; }, function (v) { return $86bee5c140ae1e47$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86bee5c140ae1e47$export$dca3b0875bd9a954;
var $86bee5c140ae1e47$export$16fa2f45be04daa8;
var $86bee5c140ae1e47$export$ffb0004e005737fa;
var $86bee5c140ae1e47$export$e2c29f18771995cb;
var $86bee5c140ae1e47$export$221d75b3f55bb0bd;
var $86bee5c140ae1e47$export$5f8d39834fd61797;
var $86bee5c140ae1e47$export$74bf444e3cd11ea5;
var $86bee5c140ae1e47$export$ae55be85d98224ed;
var $86bee5c140ae1e47$export$e530037191fcd5d7;
var $86bee5c140ae1e47$export$fd42f52fd3ae1109;
var $86bee5c140ae1e47$export$c8a8987d4410bf2d;
var $86bee5c140ae1e47$export$d38cd72104c1f0e9;
var $86bee5c140ae1e47$export$7d1e3a5e95ceca43;
var $86bee5c140ae1e47$export$257a8862b851cb5b;
var $86bee5c140ae1e47$export$a8257692ac88316c;
var $86bee5c140ae1e47$export$488013bae63b21da;
var $86bee5c140ae1e47$export$7c73462e0d25e514;
var $86bee5c140ae1e47$export$7568632d0d33d16d;
var $86bee5c140ae1e47$export$88948ce120ea2619;
var $86bee5c140ae1e47$export$35808ee640e87ca7;
var $86bee5c140ae1e47$export$fae74005e78b1a27;
var $86bee5c140ae1e47$export$dc8fbce3eb94dc1e;
var $86bee5c140ae1e47$export$6a7bc4e911dc01cf;
var $86bee5c140ae1e47$export$6d9c69b0de29b591;
var $86bee5c140ae1e47$export$f680877a34711e37;
var $86bee5c140ae1e47$export$d5a552a76deda3c2;
var $86bee5c140ae1e47$export$aaabe4eda9ed9969;
var $86bee5c140ae1e47$export$e5c5a5f917a5871c;
var $86bee5c140ae1e47$export$1538c33de8887b59;
var $86bee5c140ae1e47$export$13e3392192263954;
var $86bee5c140ae1e47$export$b8f5890fc79d6aca;
var $86bee5c140ae1e47$export$60241385465d0a34;
var $86bee5c140ae1e47$export$306c0aa65ff9ec16;
var $86bee5c140ae1e47$export$7b286972b8d8ccbf;
var $86bee5c140ae1e47$export$83d89fbfd8236492;
"use strict";
var $86bee5c140ae1e47$var$l = Symbol.for("react.element"), $86bee5c140ae1e47$var$n = Symbol.for("react.portal"), $86bee5c140ae1e47$var$p = Symbol.for("react.fragment"), $86bee5c140ae1e47$var$q = Symbol.for("react.strict_mode"), $86bee5c140ae1e47$var$r = Symbol.for("react.profiler"), $86bee5c140ae1e47$var$t = Symbol.for("react.provider"), $86bee5c140ae1e47$var$u = Symbol.for("react.context"), $86bee5c140ae1e47$var$v = Symbol.for("react.forward_ref"), $86bee5c140ae1e47$var$w = Symbol.for("react.suspense"), $86bee5c140ae1e47$var$x = Symbol.for("react.memo"), $86bee5c140ae1e47$var$y = Symbol.for("react.lazy"), $86bee5c140ae1e47$var$z = Symbol.iterator;
function $86bee5c140ae1e47$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $86bee5c140ae1e47$var$z && a[$86bee5c140ae1e47$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $86bee5c140ae1e47$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $86bee5c140ae1e47$var$C = Object.assign, $86bee5c140ae1e47$var$D = {};
function $86bee5c140ae1e47$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
$86bee5c140ae1e47$var$E.prototype.isReactComponent = {};
$86bee5c140ae1e47$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$86bee5c140ae1e47$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $86bee5c140ae1e47$var$F() {}
$86bee5c140ae1e47$var$F.prototype = $86bee5c140ae1e47$var$E.prototype;
function $86bee5c140ae1e47$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $86bee5c140ae1e47$var$D;
    this.updater = e || $86bee5c140ae1e47$var$B;
}
var $86bee5c140ae1e47$var$H = $86bee5c140ae1e47$var$G.prototype = new $86bee5c140ae1e47$var$F;
$86bee5c140ae1e47$var$H.constructor = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$var$C($86bee5c140ae1e47$var$H, $86bee5c140ae1e47$var$E.prototype);
$86bee5c140ae1e47$var$H.isPureReactComponent = !0;
var $86bee5c140ae1e47$var$I = Array.isArray, $86bee5c140ae1e47$var$J = Object.prototype.hasOwnProperty, $86bee5c140ae1e47$var$K = {
    current: null
}, $86bee5c140ae1e47$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86bee5c140ae1e47$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$86bee5c140ae1e47$var$J.call(b, d) && !$86bee5c140ae1e47$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $86bee5c140ae1e47$var$K.current
    };
}
function $86bee5c140ae1e47$var$N(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $86bee5c140ae1e47$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $86bee5c140ae1e47$var$l;
}
function $86bee5c140ae1e47$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $86bee5c140ae1e47$var$P = /\/+/g;
function $86bee5c140ae1e47$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $86bee5c140ae1e47$var$escape("" + a.key) : b.toString(36);
}
function $86bee5c140ae1e47$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $86bee5c140ae1e47$var$l:
                case $86bee5c140ae1e47$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $86bee5c140ae1e47$var$Q(h, 0) : d, $86bee5c140ae1e47$var$I(c) ? (e = "", null != a && (e = a.replace($86bee5c140ae1e47$var$P, "$&/") + "/"), $86bee5c140ae1e47$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($86bee5c140ae1e47$var$O(c) && (c = $86bee5c140ae1e47$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($86bee5c140ae1e47$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($86bee5c140ae1e47$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $86bee5c140ae1e47$var$Q(k, g);
        h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    }
    else if (f = $86bee5c140ae1e47$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $86bee5c140ae1e47$var$Q(k, g++), h += $86bee5c140ae1e47$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $86bee5c140ae1e47$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $86bee5c140ae1e47$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $86bee5c140ae1e47$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $86bee5c140ae1e47$var$U = {
    current: null
}, $86bee5c140ae1e47$var$V = {
    transition: null
}, $86bee5c140ae1e47$var$W = {
    ReactCurrentDispatcher: $86bee5c140ae1e47$var$U,
    ReactCurrentBatchConfig: $86bee5c140ae1e47$var$V,
    ReactCurrentOwner: $86bee5c140ae1e47$var$K
};
$86bee5c140ae1e47$export$dca3b0875bd9a954 = {
    map: $86bee5c140ae1e47$var$S,
    forEach: function(a, b, e) {
        $86bee5c140ae1e47$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $86bee5c140ae1e47$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $86bee5c140ae1e47$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$86bee5c140ae1e47$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$86bee5c140ae1e47$export$16fa2f45be04daa8 = $86bee5c140ae1e47$var$E;
$86bee5c140ae1e47$export$ffb0004e005737fa = $86bee5c140ae1e47$var$p;
$86bee5c140ae1e47$export$e2c29f18771995cb = $86bee5c140ae1e47$var$r;
$86bee5c140ae1e47$export$221d75b3f55bb0bd = $86bee5c140ae1e47$var$G;
$86bee5c140ae1e47$export$5f8d39834fd61797 = $86bee5c140ae1e47$var$q;
$86bee5c140ae1e47$export$74bf444e3cd11ea5 = $86bee5c140ae1e47$var$w;
$86bee5c140ae1e47$export$ae55be85d98224ed = $86bee5c140ae1e47$var$W;
$86bee5c140ae1e47$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $86bee5c140ae1e47$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $86bee5c140ae1e47$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$86bee5c140ae1e47$var$J.call(b, f) && !$86bee5c140ae1e47$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $86bee5c140ae1e47$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$86bee5c140ae1e47$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $86bee5c140ae1e47$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $86bee5c140ae1e47$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$86bee5c140ae1e47$export$c8a8987d4410bf2d = $86bee5c140ae1e47$var$M;
$86bee5c140ae1e47$export$d38cd72104c1f0e9 = function(a) {
    var b = $86bee5c140ae1e47$var$M.bind(null, a);
    b.type = a;
    return b;
};
$86bee5c140ae1e47$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$86bee5c140ae1e47$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$v,
        render: a
    };
};
$86bee5c140ae1e47$export$a8257692ac88316c = $86bee5c140ae1e47$var$O;
$86bee5c140ae1e47$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $86bee5c140ae1e47$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $86bee5c140ae1e47$var$T
    };
};
$86bee5c140ae1e47$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $86bee5c140ae1e47$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$86bee5c140ae1e47$export$7568632d0d33d16d = function(a) {
    var b = $86bee5c140ae1e47$var$V.transition;
    $86bee5c140ae1e47$var$V.transition = {};
    try {
        a();
    } finally{
        $86bee5c140ae1e47$var$V.transition = b;
    }
};
$86bee5c140ae1e47$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$86bee5c140ae1e47$export$35808ee640e87ca7 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useCallback(a, b);
};
$86bee5c140ae1e47$export$fae74005e78b1a27 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useContext(a);
};
$86bee5c140ae1e47$export$dc8fbce3eb94dc1e = function() {};
$86bee5c140ae1e47$export$6a7bc4e911dc01cf = function(a) {
    return $86bee5c140ae1e47$var$U.current.useDeferredValue(a);
};
$86bee5c140ae1e47$export$6d9c69b0de29b591 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useEffect(a, b);
};
$86bee5c140ae1e47$export$f680877a34711e37 = function() {
    return $86bee5c140ae1e47$var$U.current.useId();
};
$86bee5c140ae1e47$export$d5a552a76deda3c2 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useImperativeHandle(a, b, e);
};
$86bee5c140ae1e47$export$aaabe4eda9ed9969 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useInsertionEffect(a, b);
};
$86bee5c140ae1e47$export$e5c5a5f917a5871c = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useLayoutEffect(a, b);
};
$86bee5c140ae1e47$export$1538c33de8887b59 = function(a, b) {
    return $86bee5c140ae1e47$var$U.current.useMemo(a, b);
};
$86bee5c140ae1e47$export$13e3392192263954 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useReducer(a, b, e);
};
$86bee5c140ae1e47$export$b8f5890fc79d6aca = function(a) {
    return $86bee5c140ae1e47$var$U.current.useRef(a);
};
$86bee5c140ae1e47$export$60241385465d0a34 = function(a) {
    return $86bee5c140ae1e47$var$U.current.useState(a);
};
$86bee5c140ae1e47$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $86bee5c140ae1e47$var$U.current.useSyncExternalStore(a, b, e);
};
$86bee5c140ae1e47$export$7b286972b8d8ccbf = function() {
    return $86bee5c140ae1e47$var$U.current.useTransition();
};
$86bee5c140ae1e47$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("h8vP0", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $c79bde28d689cb05$export$ae55be85d98224ed; }, function (v) { return $c79bde28d689cb05$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $c79bde28d689cb05$export$d39a5bbd09211389; }, function (v) { return $c79bde28d689cb05$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $c79bde28d689cb05$export$882461b6382ed46c; }, function (v) { return $c79bde28d689cb05$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $c79bde28d689cb05$export$466bfc07425424d5; }, function (v) { return $c79bde28d689cb05$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c79bde28d689cb05$export$cd75ccfd720a3cd4; }, function (v) { return $c79bde28d689cb05$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $c79bde28d689cb05$export$fa8d919ba61d84db; }, function (v) { return $c79bde28d689cb05$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c79bde28d689cb05$export$757ceba2d55c277e; }, function (v) { return $c79bde28d689cb05$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $c79bde28d689cb05$export$b3890eb0ae9dca99; }, function (v) { return $c79bde28d689cb05$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $c79bde28d689cb05$export$502457920280e6be; }, function (v) { return $c79bde28d689cb05$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c79bde28d689cb05$export$c78a37762a8d58e1; }, function (v) { return $c79bde28d689cb05$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $c79bde28d689cb05$export$dc54d992c10e8a18; }, function (v) { return $c79bde28d689cb05$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $c79bde28d689cb05$export$83d89fbfd8236492; }, function (v) { return $c79bde28d689cb05$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c79bde28d689cb05$export$ae55be85d98224ed;
var $c79bde28d689cb05$export$d39a5bbd09211389;
var $c79bde28d689cb05$export$882461b6382ed46c;
var $c79bde28d689cb05$export$466bfc07425424d5;
var $c79bde28d689cb05$export$cd75ccfd720a3cd4;
var $c79bde28d689cb05$export$fa8d919ba61d84db;
var $c79bde28d689cb05$export$757ceba2d55c277e;
var $c79bde28d689cb05$export$b3890eb0ae9dca99;
var $c79bde28d689cb05$export$502457920280e6be;
var $c79bde28d689cb05$export$c78a37762a8d58e1;
var $c79bde28d689cb05$export$dc54d992c10e8a18;
var $c79bde28d689cb05$export$83d89fbfd8236492;
"use strict";

var $exYeM = parcelRequire("exYeM");

var $ibqfJ = parcelRequire("ibqfJ");
function $c79bde28d689cb05$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c79bde28d689cb05$var$da = new Set, $c79bde28d689cb05$var$ea = {};
function $c79bde28d689cb05$var$fa(a, b) {
    $c79bde28d689cb05$var$ha(a, b);
    $c79bde28d689cb05$var$ha(a + "Capture", b);
}
function $c79bde28d689cb05$var$ha(a, b) {
    $c79bde28d689cb05$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$da.add(b[a]);
}
var $c79bde28d689cb05$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c79bde28d689cb05$var$ja = Object.prototype.hasOwnProperty, $c79bde28d689cb05$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c79bde28d689cb05$var$la = {}, $c79bde28d689cb05$var$ma = {};
function $c79bde28d689cb05$var$oa(a) {
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$ma, a)) return !0;
    if ($c79bde28d689cb05$var$ja.call($c79bde28d689cb05$var$la, a)) return !1;
    if ($c79bde28d689cb05$var$ka.test(a)) return $c79bde28d689cb05$var$ma[a] = !0;
    $c79bde28d689cb05$var$la[a] = !0;
    return !1;
}
function $c79bde28d689cb05$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c79bde28d689cb05$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c79bde28d689cb05$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c79bde28d689cb05$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c79bde28d689cb05$var$ra = /[\-:]([a-z])/g;
function $c79bde28d689cb05$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c79bde28d689cb05$var$ra, $c79bde28d689cb05$var$sa);
    $c79bde28d689cb05$var$z[b] = new $c79bde28d689cb05$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c79bde28d689cb05$var$z.xlinkHref = new $c79bde28d689cb05$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c79bde28d689cb05$var$z[a] = new $c79bde28d689cb05$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c79bde28d689cb05$var$ta(a, b, c, d) {
    var e = $c79bde28d689cb05$var$z.hasOwnProperty(b) ? $c79bde28d689cb05$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c79bde28d689cb05$var$qa(b, c, e, d) && (c = null), d || null === e ? $c79bde28d689cb05$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c79bde28d689cb05$var$ua = $exYeM.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c79bde28d689cb05$var$va = Symbol.for("react.element"), $c79bde28d689cb05$var$wa = Symbol.for("react.portal"), $c79bde28d689cb05$var$ya = Symbol.for("react.fragment"), $c79bde28d689cb05$var$za = Symbol.for("react.strict_mode"), $c79bde28d689cb05$var$Aa = Symbol.for("react.profiler"), $c79bde28d689cb05$var$Ba = Symbol.for("react.provider"), $c79bde28d689cb05$var$Ca = Symbol.for("react.context"), $c79bde28d689cb05$var$Da = Symbol.for("react.forward_ref"), $c79bde28d689cb05$var$Ea = Symbol.for("react.suspense"), $c79bde28d689cb05$var$Fa = Symbol.for("react.suspense_list"), $c79bde28d689cb05$var$Ga = Symbol.for("react.memo"), $c79bde28d689cb05$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c79bde28d689cb05$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c79bde28d689cb05$var$Ja = Symbol.iterator;
function $c79bde28d689cb05$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c79bde28d689cb05$var$Ja && a[$c79bde28d689cb05$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c79bde28d689cb05$var$A = Object.assign, $c79bde28d689cb05$var$La;
function $c79bde28d689cb05$var$Ma(a) {
    if (void 0 === $c79bde28d689cb05$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c79bde28d689cb05$var$La = b && b[1] || "";
    }
    return "\n" + $c79bde28d689cb05$var$La + a;
}
var $c79bde28d689cb05$var$Na = !1;
function $c79bde28d689cb05$var$Oa(a, b) {
    if (!a || $c79bde28d689cb05$var$Na) return "";
    $c79bde28d689cb05$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c79bde28d689cb05$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c79bde28d689cb05$var$Ma(a) : "";
}
function $c79bde28d689cb05$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c79bde28d689cb05$var$Ma(a.type);
        case 16:
            return $c79bde28d689cb05$var$Ma("Lazy");
        case 13:
            return $c79bde28d689cb05$var$Ma("Suspense");
        case 19:
            return $c79bde28d689cb05$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c79bde28d689cb05$var$Oa(a.type, !1), a;
        case 11:
            return a = $c79bde28d689cb05$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c79bde28d689cb05$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c79bde28d689cb05$var$ya:
            return "Fragment";
        case $c79bde28d689cb05$var$wa:
            return "Portal";
        case $c79bde28d689cb05$var$Aa:
            return "Profiler";
        case $c79bde28d689cb05$var$za:
            return "StrictMode";
        case $c79bde28d689cb05$var$Ea:
            return "Suspense";
        case $c79bde28d689cb05$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c79bde28d689cb05$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c79bde28d689cb05$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c79bde28d689cb05$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c79bde28d689cb05$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c79bde28d689cb05$var$Qa(a.type) || "Memo";
        case $c79bde28d689cb05$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c79bde28d689cb05$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c79bde28d689cb05$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c79bde28d689cb05$var$Qa(b);
        case 8:
            return b === $c79bde28d689cb05$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c79bde28d689cb05$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c79bde28d689cb05$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c79bde28d689cb05$var$Ua(a) {
    var b = $c79bde28d689cb05$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c79bde28d689cb05$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c79bde28d689cb05$var$Ua(a));
}
function $c79bde28d689cb05$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c79bde28d689cb05$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c79bde28d689cb05$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c79bde28d689cb05$var$Ya(a, b) {
    var c = b.checked;
    return $c79bde28d689cb05$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c79bde28d689cb05$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c79bde28d689cb05$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c79bde28d689cb05$var$ab(a, b) {
    b = b.checked;
    null != b && $c79bde28d689cb05$var$ta(a, "checked", b, !1);
}
function $c79bde28d689cb05$var$bb(a, b) {
    $c79bde28d689cb05$var$ab(a, b);
    var c = $c79bde28d689cb05$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c79bde28d689cb05$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c79bde28d689cb05$var$cb(a, b.type, $c79bde28d689cb05$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c79bde28d689cb05$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c79bde28d689cb05$var$cb(a, b, c) {
    if ("number" !== b || $c79bde28d689cb05$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c79bde28d689cb05$var$eb = Array.isArray;
function $c79bde28d689cb05$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c79bde28d689cb05$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c79bde28d689cb05$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c79bde28d689cb05$var$p(91));
    return $c79bde28d689cb05$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c79bde28d689cb05$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c79bde28d689cb05$var$p(92));
            if ($c79bde28d689cb05$var$eb(c)) {
                if (1 < c.length) throw Error($c79bde28d689cb05$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c79bde28d689cb05$var$Sa(c)
    };
}
function $c79bde28d689cb05$var$ib(a, b) {
    var c = $c79bde28d689cb05$var$Sa(b.value), d = $c79bde28d689cb05$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c79bde28d689cb05$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c79bde28d689cb05$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c79bde28d689cb05$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c79bde28d689cb05$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c79bde28d689cb05$var$mb, $c79bde28d689cb05$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c79bde28d689cb05$var$mb = $c79bde28d689cb05$var$mb || document.createElement("div");
        $c79bde28d689cb05$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c79bde28d689cb05$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c79bde28d689cb05$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c79bde28d689cb05$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c79bde28d689cb05$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c79bde28d689cb05$var$pb).forEach(function(a) {
    $c79bde28d689cb05$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c79bde28d689cb05$var$pb[b] = $c79bde28d689cb05$var$pb[a];
    });
});
function $c79bde28d689cb05$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c79bde28d689cb05$var$pb.hasOwnProperty(a) && $c79bde28d689cb05$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c79bde28d689cb05$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c79bde28d689cb05$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c79bde28d689cb05$var$tb = $c79bde28d689cb05$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c79bde28d689cb05$var$ub(a, b) {
    if (b) {
        if ($c79bde28d689cb05$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c79bde28d689cb05$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c79bde28d689cb05$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c79bde28d689cb05$var$p(62));
    }
}
function $c79bde28d689cb05$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c79bde28d689cb05$var$wb = null;
function $c79bde28d689cb05$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c79bde28d689cb05$var$yb = null, $c79bde28d689cb05$var$zb = null, $c79bde28d689cb05$var$Ab = null;
function $c79bde28d689cb05$var$Bb(a) {
    if (a = $c79bde28d689cb05$var$Cb(a)) {
        if ("function" !== typeof $c79bde28d689cb05$var$yb) throw Error($c79bde28d689cb05$var$p(280));
        var b = a.stateNode;
        b && (b = $c79bde28d689cb05$var$Db(b), $c79bde28d689cb05$var$yb(a.stateNode, a.type, b));
    }
}
function $c79bde28d689cb05$var$Eb(a) {
    $c79bde28d689cb05$var$zb ? $c79bde28d689cb05$var$Ab ? $c79bde28d689cb05$var$Ab.push(a) : $c79bde28d689cb05$var$Ab = [
        a
    ] : $c79bde28d689cb05$var$zb = a;
}
function $c79bde28d689cb05$var$Fb() {
    if ($c79bde28d689cb05$var$zb) {
        var a = $c79bde28d689cb05$var$zb, b = $c79bde28d689cb05$var$Ab;
        $c79bde28d689cb05$var$Ab = $c79bde28d689cb05$var$zb = null;
        $c79bde28d689cb05$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c79bde28d689cb05$var$Bb(b[a]);
    }
}
function $c79bde28d689cb05$var$Gb(a, b) {
    return a(b);
}
function $c79bde28d689cb05$var$Hb() {}
var $c79bde28d689cb05$var$Ib = !1;
function $c79bde28d689cb05$var$Jb(a, b, c) {
    if ($c79bde28d689cb05$var$Ib) return a(b, c);
    $c79bde28d689cb05$var$Ib = !0;
    try {
        return $c79bde28d689cb05$var$Gb(a, b, c);
    } finally{
        if ($c79bde28d689cb05$var$Ib = !1, null !== $c79bde28d689cb05$var$zb || null !== $c79bde28d689cb05$var$Ab) $c79bde28d689cb05$var$Hb(), $c79bde28d689cb05$var$Fb();
    }
}
function $c79bde28d689cb05$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c79bde28d689cb05$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c79bde28d689cb05$var$p(231, b, typeof c));
    return c;
}
var $c79bde28d689cb05$var$Lb = !1;
if ($c79bde28d689cb05$var$ia) try {
    var $c79bde28d689cb05$var$Mb = {};
    Object.defineProperty($c79bde28d689cb05$var$Mb, "passive", {
        get: function() {
            $c79bde28d689cb05$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
    window.removeEventListener("test", $c79bde28d689cb05$var$Mb, $c79bde28d689cb05$var$Mb);
} catch (a) {
    $c79bde28d689cb05$var$Lb = !1;
}
function $c79bde28d689cb05$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $c79bde28d689cb05$var$Ob = !1, $c79bde28d689cb05$var$Pb = null, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, $c79bde28d689cb05$var$Sb = {
    onError: function(a) {
        $c79bde28d689cb05$var$Ob = !0;
        $c79bde28d689cb05$var$Pb = a;
    }
};
function $c79bde28d689cb05$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Ob = !1;
    $c79bde28d689cb05$var$Pb = null;
    $c79bde28d689cb05$var$Nb.apply($c79bde28d689cb05$var$Sb, arguments);
}
function $c79bde28d689cb05$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c79bde28d689cb05$var$Tb.apply(this, arguments);
    if ($c79bde28d689cb05$var$Ob) {
        if ($c79bde28d689cb05$var$Ob) {
            var l = $c79bde28d689cb05$var$Pb;
            $c79bde28d689cb05$var$Ob = !1;
            $c79bde28d689cb05$var$Pb = null;
        } else throw Error($c79bde28d689cb05$var$p(198));
        $c79bde28d689cb05$var$Qb || ($c79bde28d689cb05$var$Qb = !0, $c79bde28d689cb05$var$Rb = l);
    }
}
function $c79bde28d689cb05$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c79bde28d689cb05$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c79bde28d689cb05$var$Xb(a) {
    if ($c79bde28d689cb05$var$Vb(a) !== a) throw Error($c79bde28d689cb05$var$p(188));
}
function $c79bde28d689cb05$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c79bde28d689cb05$var$Vb(a);
        if (null === b) throw Error($c79bde28d689cb05$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c79bde28d689cb05$var$Xb(e), a;
                if (f === d) return $c79bde28d689cb05$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c79bde28d689cb05$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c79bde28d689cb05$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c79bde28d689cb05$var$p(190));
    }
    if (3 !== c.tag) throw Error($c79bde28d689cb05$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c79bde28d689cb05$var$Zb(a) {
    a = $c79bde28d689cb05$var$Yb(a);
    return null !== a ? $c79bde28d689cb05$var$$b(a) : null;
}
function $c79bde28d689cb05$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c79bde28d689cb05$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$ac = $ibqfJ.unstable_scheduleCallback, $c79bde28d689cb05$var$bc = $ibqfJ.unstable_cancelCallback, $c79bde28d689cb05$var$cc = $ibqfJ.unstable_shouldYield, $c79bde28d689cb05$var$dc = $ibqfJ.unstable_requestPaint, $c79bde28d689cb05$var$B = $ibqfJ.unstable_now, $c79bde28d689cb05$var$ec = $ibqfJ.unstable_getCurrentPriorityLevel, $c79bde28d689cb05$var$fc = $ibqfJ.unstable_ImmediatePriority, $c79bde28d689cb05$var$gc = $ibqfJ.unstable_UserBlockingPriority, $c79bde28d689cb05$var$hc = $ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$ic = $ibqfJ.unstable_LowPriority, $c79bde28d689cb05$var$jc = $ibqfJ.unstable_IdlePriority, $c79bde28d689cb05$var$kc = null, $c79bde28d689cb05$var$lc = null;
function $c79bde28d689cb05$var$mc(a) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberRoot) try {
        $c79bde28d689cb05$var$lc.onCommitFiberRoot($c79bde28d689cb05$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $c79bde28d689cb05$var$oc = Math.clz32 ? Math.clz32 : $c79bde28d689cb05$var$nc, $c79bde28d689cb05$var$pc = Math.log, $c79bde28d689cb05$var$qc = Math.LN2;
function $c79bde28d689cb05$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c79bde28d689cb05$var$pc(a) / $c79bde28d689cb05$var$qc | 0) | 0;
}
var $c79bde28d689cb05$var$rc = 64, $c79bde28d689cb05$var$sc = 4194304;
function $c79bde28d689cb05$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c79bde28d689cb05$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c79bde28d689cb05$var$tc(h) : (f &= g, 0 !== f && (d = $c79bde28d689cb05$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $c79bde28d689cb05$var$tc(g) : 0 !== f && (d = $c79bde28d689cb05$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c79bde28d689cb05$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c79bde28d689cb05$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c79bde28d689cb05$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c79bde28d689cb05$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c79bde28d689cb05$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c79bde28d689cb05$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c79bde28d689cb05$var$yc() {
    var a = $c79bde28d689cb05$var$rc;
    $c79bde28d689cb05$var$rc <<= 1;
    0 === ($c79bde28d689cb05$var$rc & 4194240) && ($c79bde28d689cb05$var$rc = 64);
    return a;
}
function $c79bde28d689cb05$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c79bde28d689cb05$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c79bde28d689cb05$var$oc(b);
    a[b] = c;
}
function $c79bde28d689cb05$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c79bde28d689cb05$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c79bde28d689cb05$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c79bde28d689cb05$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $c79bde28d689cb05$var$C = 0;
function $c79bde28d689cb05$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c79bde28d689cb05$var$Ec, $c79bde28d689cb05$var$Fc, $c79bde28d689cb05$var$Gc, $c79bde28d689cb05$var$Hc, $c79bde28d689cb05$var$Ic, $c79bde28d689cb05$var$Jc = !1, $c79bde28d689cb05$var$Kc = [], $c79bde28d689cb05$var$Lc = null, $c79bde28d689cb05$var$Mc = null, $c79bde28d689cb05$var$Nc = null, $c79bde28d689cb05$var$Oc = new Map, $c79bde28d689cb05$var$Pc = new Map, $c79bde28d689cb05$var$Qc = [], $c79bde28d689cb05$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c79bde28d689cb05$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c79bde28d689cb05$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c79bde28d689cb05$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $c79bde28d689cb05$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $c79bde28d689cb05$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c79bde28d689cb05$var$Pc.delete(b.pointerId);
    }
}
function $c79bde28d689cb05$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c79bde28d689cb05$var$Cb(b), null !== b && $c79bde28d689cb05$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c79bde28d689cb05$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c79bde28d689cb05$var$Lc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $c79bde28d689cb05$var$Mc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $c79bde28d689cb05$var$Nc = $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c79bde28d689cb05$var$Oc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c79bde28d689cb05$var$Pc.set(f, $c79bde28d689cb05$var$Tc($c79bde28d689cb05$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c79bde28d689cb05$var$Vc(a) {
    var b = $c79bde28d689cb05$var$Wc(a.target);
    if (null !== b) {
        var c = $c79bde28d689cb05$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c79bde28d689cb05$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c79bde28d689cb05$var$Ic(a.priority, function() {
                        $c79bde28d689cb05$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c79bde28d689cb05$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c79bde28d689cb05$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c79bde28d689cb05$var$wb = d;
            c.target.dispatchEvent(d);
            $c79bde28d689cb05$var$wb = null;
        } else return b = $c79bde28d689cb05$var$Cb(c), null !== b && $c79bde28d689cb05$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c79bde28d689cb05$var$Zc(a, b, c) {
    $c79bde28d689cb05$var$Xc(a) && c.delete(b);
}
function $c79bde28d689cb05$var$$c() {
    $c79bde28d689cb05$var$Jc = !1;
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Lc) && ($c79bde28d689cb05$var$Lc = null);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Mc) && ($c79bde28d689cb05$var$Mc = null);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$Xc($c79bde28d689cb05$var$Nc) && ($c79bde28d689cb05$var$Nc = null);
    $c79bde28d689cb05$var$Oc.forEach($c79bde28d689cb05$var$Zc);
    $c79bde28d689cb05$var$Pc.forEach($c79bde28d689cb05$var$Zc);
}
function $c79bde28d689cb05$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c79bde28d689cb05$var$Jc || ($c79bde28d689cb05$var$Jc = !0, $ibqfJ.unstable_scheduleCallback($ibqfJ.unstable_NormalPriority, $c79bde28d689cb05$var$$c)));
}
function $c79bde28d689cb05$var$bd(a) {
    function b(b) {
        return $c79bde28d689cb05$var$ad(b, a);
    }
    if (0 < $c79bde28d689cb05$var$Kc.length) {
        $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Kc[0], a);
        for(var c = 1; c < $c79bde28d689cb05$var$Kc.length; c++){
            var d = $c79bde28d689cb05$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c79bde28d689cb05$var$Lc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Lc, a);
    null !== $c79bde28d689cb05$var$Mc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Mc, a);
    null !== $c79bde28d689cb05$var$Nc && $c79bde28d689cb05$var$ad($c79bde28d689cb05$var$Nc, a);
    $c79bde28d689cb05$var$Oc.forEach(b);
    $c79bde28d689cb05$var$Pc.forEach(b);
    for(c = 0; c < $c79bde28d689cb05$var$Qc.length; c++)d = $c79bde28d689cb05$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c79bde28d689cb05$var$Qc.length && (c = $c79bde28d689cb05$var$Qc[0], null === c.blockedOn);)$c79bde28d689cb05$var$Vc(c), null === c.blockedOn && $c79bde28d689cb05$var$Qc.shift();
}
var $c79bde28d689cb05$var$cd = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$dd = !0;
function $c79bde28d689cb05$var$ed(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$gd(a, b, c, d) {
    var e = $c79bde28d689cb05$var$C, f = $c79bde28d689cb05$var$cd.transition;
    $c79bde28d689cb05$var$cd.transition = null;
    try {
        $c79bde28d689cb05$var$C = 4, $c79bde28d689cb05$var$fd(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$C = e, $c79bde28d689cb05$var$cd.transition = f;
    }
}
function $c79bde28d689cb05$var$fd(a, b, c, d) {
    if ($c79bde28d689cb05$var$dd) {
        var e = $c79bde28d689cb05$var$Yc(a, b, c, d);
        if (null === e) $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c), $c79bde28d689cb05$var$Sc(a, d);
        else if ($c79bde28d689cb05$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($c79bde28d689cb05$var$Sc(a, d), b & 4 && -1 < $c79bde28d689cb05$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $c79bde28d689cb05$var$Cb(e);
                null !== f && $c79bde28d689cb05$var$Ec(f);
                f = $c79bde28d689cb05$var$Yc(a, b, c, d);
                null === f && $c79bde28d689cb05$var$hd(a, b, d, $c79bde28d689cb05$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c79bde28d689cb05$var$hd(a, b, d, null, c);
    }
}
var $c79bde28d689cb05$var$id = null;
function $c79bde28d689cb05$var$Yc(a, b, c, d) {
    $c79bde28d689cb05$var$id = null;
    a = $c79bde28d689cb05$var$xb(d);
    a = $c79bde28d689cb05$var$Wc(a);
    if (null !== a) {
        if (b = $c79bde28d689cb05$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c79bde28d689cb05$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c79bde28d689cb05$var$id = a;
    return null;
}
function $c79bde28d689cb05$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c79bde28d689cb05$var$ec()){
                case $c79bde28d689cb05$var$fc:
                    return 1;
                case $c79bde28d689cb05$var$gc:
                    return 4;
                case $c79bde28d689cb05$var$hc:
                case $c79bde28d689cb05$var$ic:
                    return 16;
                case $c79bde28d689cb05$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ld = null, $c79bde28d689cb05$var$md = null;
function $c79bde28d689cb05$var$nd() {
    if ($c79bde28d689cb05$var$md) return $c79bde28d689cb05$var$md;
    var a, b = $c79bde28d689cb05$var$ld, c = b.length, d, e = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c79bde28d689cb05$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c79bde28d689cb05$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c79bde28d689cb05$var$pd() {
    return !0;
}
function $c79bde28d689cb05$var$qd() {
    return !1;
}
function $c79bde28d689cb05$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c79bde28d689cb05$var$pd : $c79bde28d689cb05$var$qd;
        this.isPropagationStopped = $c79bde28d689cb05$var$qd;
        return this;
    }
    $c79bde28d689cb05$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c79bde28d689cb05$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c79bde28d689cb05$var$pd);
        },
        persist: function() {},
        isPersistent: $c79bde28d689cb05$var$pd
    });
    return b;
}
var $c79bde28d689cb05$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c79bde28d689cb05$var$td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$sd), $c79bde28d689cb05$var$ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    view: 0,
    detail: 0
}), $c79bde28d689cb05$var$vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$ud), $c79bde28d689cb05$var$wd, $c79bde28d689cb05$var$xd, $c79bde28d689cb05$var$yd, $c79bde28d689cb05$var$Ad = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c79bde28d689cb05$var$yd && ($c79bde28d689cb05$var$yd && "mousemove" === a.type ? ($c79bde28d689cb05$var$wd = a.screenX - $c79bde28d689cb05$var$yd.screenX, $c79bde28d689cb05$var$xd = a.screenY - $c79bde28d689cb05$var$yd.screenY) : $c79bde28d689cb05$var$xd = $c79bde28d689cb05$var$wd = 0, $c79bde28d689cb05$var$yd = a);
        return $c79bde28d689cb05$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c79bde28d689cb05$var$xd;
    }
}), $c79bde28d689cb05$var$Bd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ad), $c79bde28d689cb05$var$Cd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    dataTransfer: 0
}), $c79bde28d689cb05$var$Dd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Cd), $c79bde28d689cb05$var$Ed = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    relatedTarget: 0
}), $c79bde28d689cb05$var$Fd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ed), $c79bde28d689cb05$var$Gd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Hd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Gd), $c79bde28d689cb05$var$Id = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c79bde28d689cb05$var$Jd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Id), $c79bde28d689cb05$var$Kd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    data: 0
}), $c79bde28d689cb05$var$Ld = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Kd), $c79bde28d689cb05$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c79bde28d689cb05$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c79bde28d689cb05$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c79bde28d689cb05$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c79bde28d689cb05$var$Od[a]) ? !!b[a] : !1;
}
function $c79bde28d689cb05$var$zd() {
    return $c79bde28d689cb05$var$Pd;
}
var $c79bde28d689cb05$var$Qd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $c79bde28d689cb05$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c79bde28d689cb05$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c79bde28d689cb05$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c79bde28d689cb05$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c79bde28d689cb05$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c79bde28d689cb05$var$Rd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Qd), $c79bde28d689cb05$var$Sd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c79bde28d689cb05$var$Td = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Sd), $c79bde28d689cb05$var$Ud = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c79bde28d689cb05$var$zd
}), $c79bde28d689cb05$var$Vd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Ud), $c79bde28d689cb05$var$Wd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c79bde28d689cb05$var$Xd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Wd), $c79bde28d689cb05$var$Yd = $c79bde28d689cb05$var$A({}, $c79bde28d689cb05$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c79bde28d689cb05$var$Zd = $c79bde28d689cb05$var$rd($c79bde28d689cb05$var$Yd), $c79bde28d689cb05$var$$d = [
    9,
    13,
    27,
    32
], $c79bde28d689cb05$var$ae = $c79bde28d689cb05$var$ia && "CompositionEvent" in window, $c79bde28d689cb05$var$be = null;
$c79bde28d689cb05$var$ia && "documentMode" in document && ($c79bde28d689cb05$var$be = document.documentMode);
var $c79bde28d689cb05$var$ce = $c79bde28d689cb05$var$ia && "TextEvent" in window && !$c79bde28d689cb05$var$be, $c79bde28d689cb05$var$de = $c79bde28d689cb05$var$ia && (!$c79bde28d689cb05$var$ae || $c79bde28d689cb05$var$be && 8 < $c79bde28d689cb05$var$be && 11 >= $c79bde28d689cb05$var$be), $c79bde28d689cb05$var$ee = String.fromCharCode(32), $c79bde28d689cb05$var$fe = !1;
function $c79bde28d689cb05$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c79bde28d689cb05$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c79bde28d689cb05$var$ie = !1;
function $c79bde28d689cb05$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $c79bde28d689cb05$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c79bde28d689cb05$var$fe = !0;
            return $c79bde28d689cb05$var$ee;
        case "textInput":
            return a = b.data, a === $c79bde28d689cb05$var$ee && $c79bde28d689cb05$var$fe ? null : a;
        default:
            return null;
    }
}
function $c79bde28d689cb05$var$ke(a, b) {
    if ($c79bde28d689cb05$var$ie) return "compositionend" === a || !$c79bde28d689cb05$var$ae && $c79bde28d689cb05$var$ge(a, b) ? (a = $c79bde28d689cb05$var$nd(), $c79bde28d689cb05$var$md = $c79bde28d689cb05$var$ld = $c79bde28d689cb05$var$kd = null, $c79bde28d689cb05$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c79bde28d689cb05$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c79bde28d689cb05$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c79bde28d689cb05$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $c79bde28d689cb05$var$ne(a, b, c, d) {
    $c79bde28d689cb05$var$Eb(d);
    b = $c79bde28d689cb05$var$oe(b, "onChange");
    0 < b.length && (c = new $c79bde28d689cb05$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c79bde28d689cb05$var$pe = null, $c79bde28d689cb05$var$qe = null;
function $c79bde28d689cb05$var$re(a) {
    $c79bde28d689cb05$var$se(a, 0);
}
function $c79bde28d689cb05$var$te(a) {
    var b = $c79bde28d689cb05$var$ue(a);
    if ($c79bde28d689cb05$var$Wa(b)) return a;
}
function $c79bde28d689cb05$var$ve(a, b) {
    if ("change" === a) return b;
}
var $c79bde28d689cb05$var$we = !1;
if ($c79bde28d689cb05$var$ia) {
    var $c79bde28d689cb05$var$xe;
    if ($c79bde28d689cb05$var$ia) {
        var $c79bde28d689cb05$var$ye = "oninput" in document;
        if (!$c79bde28d689cb05$var$ye) {
            var $c79bde28d689cb05$var$ze = document.createElement("div");
            $c79bde28d689cb05$var$ze.setAttribute("oninput", "return;");
            $c79bde28d689cb05$var$ye = "function" === typeof $c79bde28d689cb05$var$ze.oninput;
        }
        $c79bde28d689cb05$var$xe = $c79bde28d689cb05$var$ye;
    } else $c79bde28d689cb05$var$xe = !1;
    $c79bde28d689cb05$var$we = $c79bde28d689cb05$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $c79bde28d689cb05$var$Ae() {
    $c79bde28d689cb05$var$pe && ($c79bde28d689cb05$var$pe.detachEvent("onpropertychange", $c79bde28d689cb05$var$Be), $c79bde28d689cb05$var$qe = $c79bde28d689cb05$var$pe = null);
}
function $c79bde28d689cb05$var$Be(a) {
    if ("value" === a.propertyName && $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe)) {
        var b = [];
        $c79bde28d689cb05$var$ne(b, $c79bde28d689cb05$var$qe, a, $c79bde28d689cb05$var$xb(a));
        $c79bde28d689cb05$var$Jb($c79bde28d689cb05$var$re, b);
    }
}
function $c79bde28d689cb05$var$Ce(a, b, c) {
    "focusin" === a ? ($c79bde28d689cb05$var$Ae(), $c79bde28d689cb05$var$pe = b, $c79bde28d689cb05$var$qe = c, $c79bde28d689cb05$var$pe.attachEvent("onpropertychange", $c79bde28d689cb05$var$Be)) : "focusout" === a && $c79bde28d689cb05$var$Ae();
}
function $c79bde28d689cb05$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c79bde28d689cb05$var$te($c79bde28d689cb05$var$qe);
}
function $c79bde28d689cb05$var$Ee(a, b) {
    if ("click" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $c79bde28d689cb05$var$te(b);
}
function $c79bde28d689cb05$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c79bde28d689cb05$var$He = "function" === typeof Object.is ? Object.is : $c79bde28d689cb05$var$Ge;
function $c79bde28d689cb05$var$Ie(a, b) {
    if ($c79bde28d689cb05$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c79bde28d689cb05$var$ja.call(b, e) || !$c79bde28d689cb05$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $c79bde28d689cb05$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c79bde28d689cb05$var$Ke(a, b) {
    var c = $c79bde28d689cb05$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c79bde28d689cb05$var$Je(c);
    }
}
function $c79bde28d689cb05$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c79bde28d689cb05$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c79bde28d689cb05$var$Me() {
    for(var a = window, b = $c79bde28d689cb05$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c79bde28d689cb05$var$Xa(a.document);
    }
    return b;
}
function $c79bde28d689cb05$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c79bde28d689cb05$var$Oe(a) {
    var b = $c79bde28d689cb05$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c79bde28d689cb05$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c79bde28d689cb05$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c79bde28d689cb05$var$Ke(c, f);
                var g = $c79bde28d689cb05$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c79bde28d689cb05$var$Pe = $c79bde28d689cb05$var$ia && "documentMode" in document && 11 >= document.documentMode, $c79bde28d689cb05$var$Qe = null, $c79bde28d689cb05$var$Re = null, $c79bde28d689cb05$var$Se = null, $c79bde28d689cb05$var$Te = !1;
function $c79bde28d689cb05$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c79bde28d689cb05$var$Te || null == $c79bde28d689cb05$var$Qe || $c79bde28d689cb05$var$Qe !== $c79bde28d689cb05$var$Xa(d) || (d = $c79bde28d689cb05$var$Qe, "selectionStart" in d && $c79bde28d689cb05$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c79bde28d689cb05$var$Se && $c79bde28d689cb05$var$Ie($c79bde28d689cb05$var$Se, d) || ($c79bde28d689cb05$var$Se = d, d = $c79bde28d689cb05$var$oe($c79bde28d689cb05$var$Re, "onSelect"), 0 < d.length && (b = new $c79bde28d689cb05$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c79bde28d689cb05$var$Qe)));
}
function $c79bde28d689cb05$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c79bde28d689cb05$var$We = {
    animationend: $c79bde28d689cb05$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $c79bde28d689cb05$var$Ve("Animation", "AnimationIteration"),
    animationstart: $c79bde28d689cb05$var$Ve("Animation", "AnimationStart"),
    transitionend: $c79bde28d689cb05$var$Ve("Transition", "TransitionEnd")
}, $c79bde28d689cb05$var$Xe = {}, $c79bde28d689cb05$var$Ye = {};
$c79bde28d689cb05$var$ia && ($c79bde28d689cb05$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $c79bde28d689cb05$var$We.animationend.animation, delete $c79bde28d689cb05$var$We.animationiteration.animation, delete $c79bde28d689cb05$var$We.animationstart.animation), "TransitionEvent" in window || delete $c79bde28d689cb05$var$We.transitionend.transition);
function $c79bde28d689cb05$var$Ze(a) {
    if ($c79bde28d689cb05$var$Xe[a]) return $c79bde28d689cb05$var$Xe[a];
    if (!$c79bde28d689cb05$var$We[a]) return a;
    var b = $c79bde28d689cb05$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c79bde28d689cb05$var$Ye) return $c79bde28d689cb05$var$Xe[a] = b[c];
    return a;
}
var $c79bde28d689cb05$var$$e = $c79bde28d689cb05$var$Ze("animationend"), $c79bde28d689cb05$var$af = $c79bde28d689cb05$var$Ze("animationiteration"), $c79bde28d689cb05$var$bf = $c79bde28d689cb05$var$Ze("animationstart"), $c79bde28d689cb05$var$cf = $c79bde28d689cb05$var$Ze("transitionend"), $c79bde28d689cb05$var$df = new Map, $c79bde28d689cb05$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c79bde28d689cb05$var$ff(a, b) {
    $c79bde28d689cb05$var$df.set(a, b);
    $c79bde28d689cb05$var$fa(b, [
        a
    ]);
}
for(var $c79bde28d689cb05$var$gf = 0; $c79bde28d689cb05$var$gf < $c79bde28d689cb05$var$ef.length; $c79bde28d689cb05$var$gf++){
    var $c79bde28d689cb05$var$hf = $c79bde28d689cb05$var$ef[$c79bde28d689cb05$var$gf], $c79bde28d689cb05$var$jf = $c79bde28d689cb05$var$hf.toLowerCase(), $c79bde28d689cb05$var$kf = $c79bde28d689cb05$var$hf[0].toUpperCase() + $c79bde28d689cb05$var$hf.slice(1);
    $c79bde28d689cb05$var$ff($c79bde28d689cb05$var$jf, "on" + $c79bde28d689cb05$var$kf);
}
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$$e, "onAnimationEnd");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$af, "onAnimationIteration");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$bf, "onAnimationStart");
$c79bde28d689cb05$var$ff("dblclick", "onDoubleClick");
$c79bde28d689cb05$var$ff("focusin", "onFocus");
$c79bde28d689cb05$var$ff("focusout", "onBlur");
$c79bde28d689cb05$var$ff($c79bde28d689cb05$var$cf, "onTransitionEnd");
$c79bde28d689cb05$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c79bde28d689cb05$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c79bde28d689cb05$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c79bde28d689cb05$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c79bde28d689cb05$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c79bde28d689cb05$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c79bde28d689cb05$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c79bde28d689cb05$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($c79bde28d689cb05$var$lf));
function $c79bde28d689cb05$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c79bde28d689cb05$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c79bde28d689cb05$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c79bde28d689cb05$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($c79bde28d689cb05$var$Qb) throw a = $c79bde28d689cb05$var$Rb, $c79bde28d689cb05$var$Qb = !1, $c79bde28d689cb05$var$Rb = null, a;
}
function $c79bde28d689cb05$var$D(a, b) {
    var c = b[$c79bde28d689cb05$var$of];
    void 0 === c && (c = b[$c79bde28d689cb05$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c79bde28d689cb05$var$pf(b, a, 2, !1), c.add(d));
}
function $c79bde28d689cb05$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c79bde28d689cb05$var$pf(c, a, d, b);
}
var $c79bde28d689cb05$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $c79bde28d689cb05$var$sf(a) {
    if (!a[$c79bde28d689cb05$var$rf]) {
        a[$c79bde28d689cb05$var$rf] = !0;
        $c79bde28d689cb05$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c79bde28d689cb05$var$mf.has(b) || $c79bde28d689cb05$var$qf(b, !1, a), $c79bde28d689cb05$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c79bde28d689cb05$var$rf] || (b[$c79bde28d689cb05$var$rf] = !0, $c79bde28d689cb05$var$qf("selectionchange", !1, b));
    }
}
function $c79bde28d689cb05$var$pf(a, b, c, d) {
    switch($c79bde28d689cb05$var$jd(b)){
        case 1:
            var e = $c79bde28d689cb05$var$ed;
            break;
        case 4:
            e = $c79bde28d689cb05$var$gd;
            break;
        default:
            e = $c79bde28d689cb05$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c79bde28d689cb05$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c79bde28d689cb05$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c79bde28d689cb05$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c79bde28d689cb05$var$Jb(function() {
        var d = f, e = $c79bde28d689cb05$var$xb(c), g = [];
        a: {
            var h = $c79bde28d689cb05$var$df.get(a);
            if (void 0 !== h) {
                var k = $c79bde28d689cb05$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $c79bde28d689cb05$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c79bde28d689cb05$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c79bde28d689cb05$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c79bde28d689cb05$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c79bde28d689cb05$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c79bde28d689cb05$var$Vd;
                        break;
                    case $c79bde28d689cb05$var$$e:
                    case $c79bde28d689cb05$var$af:
                    case $c79bde28d689cb05$var$bf:
                        k = $c79bde28d689cb05$var$Hd;
                        break;
                    case $c79bde28d689cb05$var$cf:
                        k = $c79bde28d689cb05$var$Xd;
                        break;
                    case "scroll":
                        k = $c79bde28d689cb05$var$vd;
                        break;
                    case "wheel":
                        k = $c79bde28d689cb05$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c79bde28d689cb05$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c79bde28d689cb05$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $c79bde28d689cb05$var$Kb(w, x), null != F && t.push($c79bde28d689cb05$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c79bde28d689cb05$var$wb && (n = c.relatedTarget || c.fromElement) && ($c79bde28d689cb05$var$Wc(n) || n[$c79bde28d689cb05$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $c79bde28d689cb05$var$Wc(n) : null, null !== n && (J = $c79bde28d689cb05$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $c79bde28d689cb05$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $c79bde28d689cb05$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $c79bde28d689cb05$var$ue(k);
                        u = null == n ? h : $c79bde28d689cb05$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $c79bde28d689cb05$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $c79bde28d689cb05$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $c79bde28d689cb05$var$vf(F))u++;
                            for(; 0 < w - u;)t = $c79bde28d689cb05$var$vf(t), w--;
                            for(; 0 < u - w;)x = $c79bde28d689cb05$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $c79bde28d689cb05$var$vf(t);
                                x = $c79bde28d689cb05$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $c79bde28d689cb05$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $c79bde28d689cb05$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $c79bde28d689cb05$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $c79bde28d689cb05$var$ve;
                else if ($c79bde28d689cb05$var$me(h)) {
                    if ($c79bde28d689cb05$var$we) na = $c79bde28d689cb05$var$Fe;
                    else {
                        na = $c79bde28d689cb05$var$De;
                        var xa = $c79bde28d689cb05$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $c79bde28d689cb05$var$Ee);
                if (na && (na = na(a, d))) {
                    $c79bde28d689cb05$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $c79bde28d689cb05$var$cb(h, "number", h.value);
            }
            xa = d ? $c79bde28d689cb05$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($c79bde28d689cb05$var$me(xa) || "true" === xa.contentEditable) $c79bde28d689cb05$var$Qe = xa, $c79bde28d689cb05$var$Re = d, $c79bde28d689cb05$var$Se = null;
                    break;
                case "focusout":
                    $c79bde28d689cb05$var$Se = $c79bde28d689cb05$var$Re = $c79bde28d689cb05$var$Qe = null;
                    break;
                case "mousedown":
                    $c79bde28d689cb05$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c79bde28d689cb05$var$Te = !1;
                    $c79bde28d689cb05$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($c79bde28d689cb05$var$Pe) break;
                case "keydown":
                case "keyup":
                    $c79bde28d689cb05$var$Ue(g, c, e);
            }
            var $a;
            if ($c79bde28d689cb05$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $c79bde28d689cb05$var$ie ? $c79bde28d689cb05$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($c79bde28d689cb05$var$de && "ko" !== c.locale && ($c79bde28d689cb05$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $c79bde28d689cb05$var$ie && ($a = $c79bde28d689cb05$var$nd()) : ($c79bde28d689cb05$var$kd = e, $c79bde28d689cb05$var$ld = "value" in $c79bde28d689cb05$var$kd ? $c79bde28d689cb05$var$kd.value : $c79bde28d689cb05$var$kd.textContent, $c79bde28d689cb05$var$ie = !0)), xa = $c79bde28d689cb05$var$oe(d, ba), 0 < xa.length && (ba = new $c79bde28d689cb05$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $c79bde28d689cb05$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $c79bde28d689cb05$var$ce ? $c79bde28d689cb05$var$je(a, c) : $c79bde28d689cb05$var$ke(a, c)) d = $c79bde28d689cb05$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $c79bde28d689cb05$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $c79bde28d689cb05$var$se(g, b);
    });
}
function $c79bde28d689cb05$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c79bde28d689cb05$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c79bde28d689cb05$var$Kb(a, c), null != f && d.unshift($c79bde28d689cb05$var$tf(a, f, e)), f = $c79bde28d689cb05$var$Kb(a, b), null != f && d.push($c79bde28d689cb05$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c79bde28d689cb05$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c79bde28d689cb05$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.unshift($c79bde28d689cb05$var$tf(c, k, h))) : e || (k = $c79bde28d689cb05$var$Kb(c, f), null != k && g.push($c79bde28d689cb05$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c79bde28d689cb05$var$xf = /\r\n?/g, $c79bde28d689cb05$var$yf = /\u0000|\uFFFD/g;
function $c79bde28d689cb05$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c79bde28d689cb05$var$xf, "\n").replace($c79bde28d689cb05$var$yf, "");
}
function $c79bde28d689cb05$var$Af(a, b, c) {
    b = $c79bde28d689cb05$var$zf(b);
    if ($c79bde28d689cb05$var$zf(a) !== b && c) throw Error($c79bde28d689cb05$var$p(425));
}
function $c79bde28d689cb05$var$Bf() {}
var $c79bde28d689cb05$var$Cf = null, $c79bde28d689cb05$var$Df = null;
function $c79bde28d689cb05$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c79bde28d689cb05$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $c79bde28d689cb05$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c79bde28d689cb05$var$Hf = "function" === typeof Promise ? Promise : void 0, $c79bde28d689cb05$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c79bde28d689cb05$var$Hf ? function(a) {
    return $c79bde28d689cb05$var$Hf.resolve(null).then(a).catch($c79bde28d689cb05$var$If);
} : $c79bde28d689cb05$var$Ff;
function $c79bde28d689cb05$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c79bde28d689cb05$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c79bde28d689cb05$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c79bde28d689cb05$var$bd(b);
}
function $c79bde28d689cb05$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c79bde28d689cb05$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nf = Math.random().toString(36).slice(2), $c79bde28d689cb05$var$Of = "__reactFiber$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Pf = "__reactProps$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$uf = "__reactContainer$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$of = "__reactEvents$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Qf = "__reactListeners$" + $c79bde28d689cb05$var$Nf, $c79bde28d689cb05$var$Rf = "__reactHandles$" + $c79bde28d689cb05$var$Nf;
function $c79bde28d689cb05$var$Wc(a) {
    var b = a[$c79bde28d689cb05$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c79bde28d689cb05$var$uf] || c[$c79bde28d689cb05$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c79bde28d689cb05$var$Mf(a); null !== a;){
                if (c = a[$c79bde28d689cb05$var$Of]) return c;
                a = $c79bde28d689cb05$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c79bde28d689cb05$var$Cb(a) {
    a = a[$c79bde28d689cb05$var$Of] || a[$c79bde28d689cb05$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c79bde28d689cb05$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c79bde28d689cb05$var$p(33));
}
function $c79bde28d689cb05$var$Db(a) {
    return a[$c79bde28d689cb05$var$Pf] || null;
}
var $c79bde28d689cb05$var$Sf = [], $c79bde28d689cb05$var$Tf = -1;
function $c79bde28d689cb05$var$Uf(a) {
    return {
        current: a
    };
}
function $c79bde28d689cb05$var$E(a) {
    0 > $c79bde28d689cb05$var$Tf || (a.current = $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf], $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = null, $c79bde28d689cb05$var$Tf--);
}
function $c79bde28d689cb05$var$G(a, b) {
    $c79bde28d689cb05$var$Tf++;
    $c79bde28d689cb05$var$Sf[$c79bde28d689cb05$var$Tf] = a.current;
    a.current = b;
}
var $c79bde28d689cb05$var$Vf = {}, $c79bde28d689cb05$var$H = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Vf), $c79bde28d689cb05$var$Wf = $c79bde28d689cb05$var$Uf(!1), $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$Vf;
function $c79bde28d689cb05$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c79bde28d689cb05$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c79bde28d689cb05$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c79bde28d689cb05$var$$f() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
}
function $c79bde28d689cb05$var$ag(a, b, c) {
    if ($c79bde28d689cb05$var$H.current !== $c79bde28d689cb05$var$Vf) throw Error($c79bde28d689cb05$var$p(168));
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
function $c79bde28d689cb05$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c79bde28d689cb05$var$p(108, $c79bde28d689cb05$var$Ra(a) || "Unknown", e));
    return $c79bde28d689cb05$var$A({}, c, d);
}
function $c79bde28d689cb05$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c79bde28d689cb05$var$Vf;
    $c79bde28d689cb05$var$Xf = $c79bde28d689cb05$var$H.current;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, $c79bde28d689cb05$var$Wf.current);
    return !0;
}
function $c79bde28d689cb05$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c79bde28d689cb05$var$p(169));
    c ? (a = $c79bde28d689cb05$var$bg(a, b, $c79bde28d689cb05$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$H, a)) : $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Wf, c);
}
var $c79bde28d689cb05$var$eg = null, $c79bde28d689cb05$var$fg = !1, $c79bde28d689cb05$var$gg = !1;
function $c79bde28d689cb05$var$hg(a) {
    null === $c79bde28d689cb05$var$eg ? $c79bde28d689cb05$var$eg = [
        a
    ] : $c79bde28d689cb05$var$eg.push(a);
}
function $c79bde28d689cb05$var$ig(a) {
    $c79bde28d689cb05$var$fg = !0;
    $c79bde28d689cb05$var$hg(a);
}
function $c79bde28d689cb05$var$jg() {
    if (!$c79bde28d689cb05$var$gg && null !== $c79bde28d689cb05$var$eg) {
        $c79bde28d689cb05$var$gg = !0;
        var a = 0, b = $c79bde28d689cb05$var$C;
        try {
            var c = $c79bde28d689cb05$var$eg;
            for($c79bde28d689cb05$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c79bde28d689cb05$var$eg = null;
            $c79bde28d689cb05$var$fg = !1;
        } catch (e) {
            throw null !== $c79bde28d689cb05$var$eg && ($c79bde28d689cb05$var$eg = $c79bde28d689cb05$var$eg.slice(a + 1)), $c79bde28d689cb05$var$ac($c79bde28d689cb05$var$fc, $c79bde28d689cb05$var$jg), e;
        } finally{
            $c79bde28d689cb05$var$C = b, $c79bde28d689cb05$var$gg = !1;
        }
    }
    return null;
}
var $c79bde28d689cb05$var$kg = [], $c79bde28d689cb05$var$lg = 0, $c79bde28d689cb05$var$mg = null, $c79bde28d689cb05$var$ng = 0, $c79bde28d689cb05$var$og = [], $c79bde28d689cb05$var$pg = 0, $c79bde28d689cb05$var$qg = null, $c79bde28d689cb05$var$rg = 1, $c79bde28d689cb05$var$sg = "";
function $c79bde28d689cb05$var$tg(a, b) {
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$ng;
    $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg++] = $c79bde28d689cb05$var$mg;
    $c79bde28d689cb05$var$mg = a;
    $c79bde28d689cb05$var$ng = b;
}
function $c79bde28d689cb05$var$ug(a, b, c) {
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg;
    $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg;
    $c79bde28d689cb05$var$qg = a;
    var d = $c79bde28d689cb05$var$rg;
    a = $c79bde28d689cb05$var$sg;
    var e = 32 - $c79bde28d689cb05$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c79bde28d689cb05$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c79bde28d689cb05$var$rg = 1 << 32 - $c79bde28d689cb05$var$oc(b) + e | c << e | d;
        $c79bde28d689cb05$var$sg = f + a;
    } else $c79bde28d689cb05$var$rg = 1 << f | c << e | d, $c79bde28d689cb05$var$sg = a;
}
function $c79bde28d689cb05$var$vg(a) {
    null !== a.return && ($c79bde28d689cb05$var$tg(a, 1), $c79bde28d689cb05$var$ug(a, 1, 0));
}
function $c79bde28d689cb05$var$wg(a) {
    for(; a === $c79bde28d689cb05$var$mg;)$c79bde28d689cb05$var$mg = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null, $c79bde28d689cb05$var$ng = $c79bde28d689cb05$var$kg[--$c79bde28d689cb05$var$lg], $c79bde28d689cb05$var$kg[$c79bde28d689cb05$var$lg] = null;
    for(; a === $c79bde28d689cb05$var$qg;)$c79bde28d689cb05$var$qg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$sg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null, $c79bde28d689cb05$var$rg = $c79bde28d689cb05$var$og[--$c79bde28d689cb05$var$pg], $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg] = null;
}
var $c79bde28d689cb05$var$xg = null, $c79bde28d689cb05$var$yg = null, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$zg = null;
function $c79bde28d689cb05$var$Ag(a, b) {
    var c = $c79bde28d689cb05$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c79bde28d689cb05$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c79bde28d689cb05$var$qg ? {
                id: $c79bde28d689cb05$var$rg,
                overflow: $c79bde28d689cb05$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c79bde28d689cb05$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c79bde28d689cb05$var$xg = a, $c79bde28d689cb05$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c79bde28d689cb05$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c79bde28d689cb05$var$Eg(a) {
    if ($c79bde28d689cb05$var$I) {
        var b = $c79bde28d689cb05$var$yg;
        if (b) {
            var c = b;
            if (!$c79bde28d689cb05$var$Cg(a, b)) {
                if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
                b = $c79bde28d689cb05$var$Lf(c.nextSibling);
                var d = $c79bde28d689cb05$var$xg;
                b && $c79bde28d689cb05$var$Cg(a, b) ? $c79bde28d689cb05$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $c79bde28d689cb05$var$I = !1, $c79bde28d689cb05$var$xg = a);
            }
        } else {
            if ($c79bde28d689cb05$var$Dg(a)) throw Error($c79bde28d689cb05$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c79bde28d689cb05$var$I = !1;
            $c79bde28d689cb05$var$xg = a;
        }
    }
}
function $c79bde28d689cb05$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c79bde28d689cb05$var$xg = a;
}
function $c79bde28d689cb05$var$Gg(a) {
    if (a !== $c79bde28d689cb05$var$xg) return !1;
    if (!$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$Fg(a), $c79bde28d689cb05$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c79bde28d689cb05$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $c79bde28d689cb05$var$yg)) {
        if ($c79bde28d689cb05$var$Dg(a)) throw $c79bde28d689cb05$var$Hg(), Error($c79bde28d689cb05$var$p(418));
        for(; b;)$c79bde28d689cb05$var$Ag(a, b), b = $c79bde28d689cb05$var$Lf(b.nextSibling);
    }
    $c79bde28d689cb05$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c79bde28d689cb05$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c79bde28d689cb05$var$yg = null;
        }
    } else $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg ? $c79bde28d689cb05$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c79bde28d689cb05$var$Hg() {
    for(var a = $c79bde28d689cb05$var$yg; a;)a = $c79bde28d689cb05$var$Lf(a.nextSibling);
}
function $c79bde28d689cb05$var$Ig() {
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$xg = null;
    $c79bde28d689cb05$var$I = !1;
}
function $c79bde28d689cb05$var$Jg(a) {
    null === $c79bde28d689cb05$var$zg ? $c79bde28d689cb05$var$zg = [
        a
    ] : $c79bde28d689cb05$var$zg.push(a);
}
var $c79bde28d689cb05$var$Kg = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig;
function $c79bde28d689cb05$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $c79bde28d689cb05$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $c79bde28d689cb05$var$Mg = $c79bde28d689cb05$var$Uf(null), $c79bde28d689cb05$var$Ng = null, $c79bde28d689cb05$var$Og = null, $c79bde28d689cb05$var$Pg = null;
function $c79bde28d689cb05$var$Qg() {
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Ng = null;
}
function $c79bde28d689cb05$var$Rg(a) {
    var b = $c79bde28d689cb05$var$Mg.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Mg);
    a._currentValue = b;
}
function $c79bde28d689cb05$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c79bde28d689cb05$var$Tg(a, b) {
    $c79bde28d689cb05$var$Ng = a;
    $c79bde28d689cb05$var$Pg = $c79bde28d689cb05$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c79bde28d689cb05$var$Ug = !0), a.firstContext = null);
}
function $c79bde28d689cb05$var$Vg(a) {
    var b = a._currentValue;
    if ($c79bde28d689cb05$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c79bde28d689cb05$var$Og) {
            if (null === $c79bde28d689cb05$var$Ng) throw Error($c79bde28d689cb05$var$p(308));
            $c79bde28d689cb05$var$Og = a;
            $c79bde28d689cb05$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c79bde28d689cb05$var$Og = $c79bde28d689cb05$var$Og.next = a;
    }
    return b;
}
var $c79bde28d689cb05$var$Wg = null;
function $c79bde28d689cb05$var$Xg(a) {
    null === $c79bde28d689cb05$var$Wg ? $c79bde28d689cb05$var$Wg = [
        a
    ] : $c79bde28d689cb05$var$Wg.push(a);
}
function $c79bde28d689cb05$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c79bde28d689cb05$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c79bde28d689cb05$var$Zg(a, d);
}
function $c79bde28d689cb05$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c79bde28d689cb05$var$$g = !1;
function $c79bde28d689cb05$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c79bde28d689cb05$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c79bde28d689cb05$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c79bde28d689cb05$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c79bde28d689cb05$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c79bde28d689cb05$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c79bde28d689cb05$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c79bde28d689cb05$var$Zg(a, c);
}
function $c79bde28d689cb05$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
function $c79bde28d689cb05$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c79bde28d689cb05$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $c79bde28d689cb05$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $c79bde28d689cb05$var$A({}, q, r);
                            break a;
                        case 2:
                            $c79bde28d689cb05$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c79bde28d689cb05$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c79bde28d689cb05$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c79bde28d689cb05$var$p(191, e));
            e.call(d);
        }
    }
}
var $c79bde28d689cb05$var$jh = (new $exYeM.Component).refs;
function $c79bde28d689cb05$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c79bde28d689cb05$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c79bde28d689cb05$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c79bde28d689cb05$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c79bde28d689cb05$var$L(), e = $c79bde28d689cb05$var$lh(a), f = $c79bde28d689cb05$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c79bde28d689cb05$var$dh(a, f, e);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, e, d), $c79bde28d689cb05$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c79bde28d689cb05$var$L(), d = $c79bde28d689cb05$var$lh(a), e = $c79bde28d689cb05$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c79bde28d689cb05$var$dh(a, e, d);
        null !== b && ($c79bde28d689cb05$var$mh(b, a, d, c), $c79bde28d689cb05$var$eh(b, a, d));
    }
};
function $c79bde28d689cb05$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c79bde28d689cb05$var$Ie(c, d) || !$c79bde28d689cb05$var$Ie(e, f) : !0;
}
function $c79bde28d689cb05$var$ph(a, b, c) {
    var d = !1, e = $c79bde28d689cb05$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c79bde28d689cb05$var$Vg(f) : (e = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c79bde28d689cb05$var$Yf(a, e) : $c79bde28d689cb05$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c79bde28d689cb05$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c79bde28d689cb05$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c79bde28d689cb05$var$nh.enqueueReplaceState(b, b.state, null);
}
function $c79bde28d689cb05$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $c79bde28d689cb05$var$jh;
    $c79bde28d689cb05$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c79bde28d689cb05$var$Vg(f) : (f = $c79bde28d689cb05$var$Zf(b) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, e.context = $c79bde28d689cb05$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c79bde28d689cb05$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c79bde28d689cb05$var$nh.enqueueReplaceState(e, e.state, null), $c79bde28d689cb05$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c79bde28d689cb05$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c79bde28d689cb05$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c79bde28d689cb05$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $c79bde28d689cb05$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c79bde28d689cb05$var$p(284));
        if (!c._owner) throw Error($c79bde28d689cb05$var$p(290, a));
    }
    return a;
}
function $c79bde28d689cb05$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c79bde28d689cb05$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c79bde28d689cb05$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $c79bde28d689cb05$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c79bde28d689cb05$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c79bde28d689cb05$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c79bde28d689cb05$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $c79bde28d689cb05$var$sh(a, b, c), d.return = a, d;
        d = $c79bde28d689cb05$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c79bde28d689cb05$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c79bde28d689cb05$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c79bde28d689cb05$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c79bde28d689cb05$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c = $c79bde28d689cb05$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c79bde28d689cb05$var$sh(a, null, b), c.return = a, c;
                case $c79bde28d689cb05$var$wa:
                    return b = $c79bde28d689cb05$var$zh(b, a.mode, c), b.return = a, b;
                case $c79bde28d689cb05$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c79bde28d689cb05$var$eb(b) || $c79bde28d689cb05$var$Ka(b)) return b = $c79bde28d689cb05$var$Ah(b, a.mode, c, null), b.return = a, b;
            $c79bde28d689cb05$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c79bde28d689cb05$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c79bde28d689cb05$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c79bde28d689cb05$var$eb(c) || $c79bde28d689cb05$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $c79bde28d689cb05$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c79bde28d689cb05$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c79bde28d689cb05$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c79bde28d689cb05$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($c79bde28d689cb05$var$eb(d) || $c79bde28d689cb05$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $c79bde28d689cb05$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $c79bde28d689cb05$var$Ka(h);
        if ("function" !== typeof l) throw Error($c79bde28d689cb05$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c79bde28d689cb05$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c79bde28d689cb05$var$I && $c79bde28d689cb05$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c79bde28d689cb05$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c79bde28d689cb05$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c79bde28d689cb05$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c79bde28d689cb05$var$Ha && $c79bde28d689cb05$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c79bde28d689cb05$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c79bde28d689cb05$var$ya ? (d = $c79bde28d689cb05$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c79bde28d689cb05$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c79bde28d689cb05$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c79bde28d689cb05$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c79bde28d689cb05$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c79bde28d689cb05$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($c79bde28d689cb05$var$eb(f)) return n(a, d, f, h);
            if ($c79bde28d689cb05$var$Ka(f)) return t(a, d, f, h);
            $c79bde28d689cb05$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c79bde28d689cb05$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $c79bde28d689cb05$var$Bh = $c79bde28d689cb05$var$vh(!0), $c79bde28d689cb05$var$Ch = $c79bde28d689cb05$var$vh(!1), $c79bde28d689cb05$var$Dh = {}, $c79bde28d689cb05$var$Eh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Fh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh), $c79bde28d689cb05$var$Gh = $c79bde28d689cb05$var$Uf($c79bde28d689cb05$var$Dh);
function $c79bde28d689cb05$var$Hh(a) {
    if (a === $c79bde28d689cb05$var$Dh) throw Error($c79bde28d689cb05$var$p(174));
    return a;
}
function $c79bde28d689cb05$var$Ih(a, b) {
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Gh, b);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, $c79bde28d689cb05$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c79bde28d689cb05$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c79bde28d689cb05$var$lb(b, a);
    }
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, b);
}
function $c79bde28d689cb05$var$Jh() {
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh);
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Gh);
}
function $c79bde28d689cb05$var$Kh(a) {
    $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
    var b = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
    var c = $c79bde28d689cb05$var$lb(b, a.type);
    b !== c && ($c79bde28d689cb05$var$G($c79bde28d689cb05$var$Fh, a), $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Eh, c));
}
function $c79bde28d689cb05$var$Lh(a) {
    $c79bde28d689cb05$var$Fh.current === a && ($c79bde28d689cb05$var$E($c79bde28d689cb05$var$Eh), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Fh));
}
var $c79bde28d689cb05$var$M = $c79bde28d689cb05$var$Uf(0);
function $c79bde28d689cb05$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c79bde28d689cb05$var$Nh = [];
function $c79bde28d689cb05$var$Oh() {
    for(var a = 0; a < $c79bde28d689cb05$var$Nh.length; a++)$c79bde28d689cb05$var$Nh[a]._workInProgressVersionPrimary = null;
    $c79bde28d689cb05$var$Nh.length = 0;
}
var $c79bde28d689cb05$var$Ph = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$Qh = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$Rh = 0, $c79bde28d689cb05$var$N = null, $c79bde28d689cb05$var$O = null, $c79bde28d689cb05$var$P = null, $c79bde28d689cb05$var$Sh = !1, $c79bde28d689cb05$var$Th = !1, $c79bde28d689cb05$var$Uh = 0, $c79bde28d689cb05$var$Vh = 0;
function $c79bde28d689cb05$var$Q() {
    throw Error($c79bde28d689cb05$var$p(321));
}
function $c79bde28d689cb05$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c79bde28d689cb05$var$He(a[c], b[c])) return !1;
    return !0;
}
function $c79bde28d689cb05$var$Xh(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$Rh = f;
    $c79bde28d689cb05$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c79bde28d689cb05$var$Ph.current = null === a || null === a.memoizedState ? $c79bde28d689cb05$var$Yh : $c79bde28d689cb05$var$Zh;
    a = c(d, e);
    if ($c79bde28d689cb05$var$Th) {
        f = 0;
        do {
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            if (25 <= f) throw Error($c79bde28d689cb05$var$p(301));
            f += 1;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = null;
            b.updateQueue = null;
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$$h;
            a = c(d, e);
        }while ($c79bde28d689cb05$var$Th);
    }
    $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
    b = null !== $c79bde28d689cb05$var$O && null !== $c79bde28d689cb05$var$O.next;
    $c79bde28d689cb05$var$Rh = 0;
    $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
    $c79bde28d689cb05$var$Sh = !1;
    if (b) throw Error($c79bde28d689cb05$var$p(300));
    return a;
}
function $c79bde28d689cb05$var$bi() {
    var a = 0 !== $c79bde28d689cb05$var$Uh;
    $c79bde28d689cb05$var$Uh = 0;
    return a;
}
function $c79bde28d689cb05$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$di() {
    if (null === $c79bde28d689cb05$var$O) {
        var a = $c79bde28d689cb05$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c79bde28d689cb05$var$O.next;
    var b = null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState : $c79bde28d689cb05$var$P.next;
    if (null !== b) $c79bde28d689cb05$var$P = b, $c79bde28d689cb05$var$O = a;
    else {
        if (null === a) throw Error($c79bde28d689cb05$var$p(310));
        $c79bde28d689cb05$var$O = a;
        a = {
            memoizedState: $c79bde28d689cb05$var$O.memoizedState,
            baseState: $c79bde28d689cb05$var$O.baseState,
            baseQueue: $c79bde28d689cb05$var$O.baseQueue,
            queue: $c79bde28d689cb05$var$O.queue,
            next: null
        };
        null === $c79bde28d689cb05$var$P ? $c79bde28d689cb05$var$N.memoizedState = $c79bde28d689cb05$var$P = a : $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$P.next = a;
    }
    return $c79bde28d689cb05$var$P;
}
function $c79bde28d689cb05$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c79bde28d689cb05$var$fi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c79bde28d689cb05$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($c79bde28d689cb05$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c79bde28d689cb05$var$N.lanes |= m;
                $c79bde28d689cb05$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c79bde28d689cb05$var$He(d, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c79bde28d689cb05$var$N.lanes |= f, $c79bde28d689cb05$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c79bde28d689cb05$var$gi(a) {
    var b = $c79bde28d689cb05$var$di(), c = b.queue;
    if (null === c) throw Error($c79bde28d689cb05$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c79bde28d689cb05$var$He(f, b.memoizedState) || ($c79bde28d689cb05$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c79bde28d689cb05$var$hi() {}
function $c79bde28d689cb05$var$ii(a, b) {
    var c = $c79bde28d689cb05$var$N, d = $c79bde28d689cb05$var$di(), e = b(), f = !$c79bde28d689cb05$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $c79bde28d689cb05$var$Ug = !0);
    d = d.queue;
    $c79bde28d689cb05$var$ji($c79bde28d689cb05$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c79bde28d689cb05$var$P && $c79bde28d689cb05$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
        0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(c, b, e);
    }
    return e;
}
function $c79bde28d689cb05$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c79bde28d689cb05$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
}
function $c79bde28d689cb05$var$ki(a, b, c) {
    return c(function() {
        $c79bde28d689cb05$var$oi(b) && $c79bde28d689cb05$var$pi(a);
    });
}
function $c79bde28d689cb05$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c79bde28d689cb05$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $c79bde28d689cb05$var$pi(a) {
    var b = $c79bde28d689cb05$var$Zg(a, 1);
    null !== b && $c79bde28d689cb05$var$mh(b, a, 1, -1);
}
function $c79bde28d689cb05$var$qi(a) {
    var b = $c79bde28d689cb05$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c79bde28d689cb05$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c79bde28d689cb05$var$ri.bind(null, $c79bde28d689cb05$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c79bde28d689cb05$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c79bde28d689cb05$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c79bde28d689cb05$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c79bde28d689cb05$var$si() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$ti(a, b, c, d) {
    var e = $c79bde28d689cb05$var$ci();
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c79bde28d689cb05$var$ui(a, b, c, d) {
    var e = $c79bde28d689cb05$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c79bde28d689cb05$var$O) {
        var g = $c79bde28d689cb05$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $c79bde28d689cb05$var$Wh(d, g.deps)) {
            e.memoizedState = $c79bde28d689cb05$var$li(b, c, f, d);
            return;
        }
    }
    $c79bde28d689cb05$var$N.flags |= a;
    e.memoizedState = $c79bde28d689cb05$var$li(1 | b, c, f, d);
}
function $c79bde28d689cb05$var$vi(a, b) {
    return $c79bde28d689cb05$var$ti(8390656, 8, a, b);
}
function $c79bde28d689cb05$var$ji(a, b) {
    return $c79bde28d689cb05$var$ui(2048, 8, a, b);
}
function $c79bde28d689cb05$var$wi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 2, a, b);
}
function $c79bde28d689cb05$var$xi(a, b) {
    return $c79bde28d689cb05$var$ui(4, 4, a, b);
}
function $c79bde28d689cb05$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c79bde28d689cb05$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c79bde28d689cb05$var$ui(4, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
}
function $c79bde28d689cb05$var$Ai() {}
function $c79bde28d689cb05$var$Bi(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Ci(a, b) {
    var c = $c79bde28d689cb05$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c79bde28d689cb05$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c79bde28d689cb05$var$Di(a, b, c) {
    if (0 === ($c79bde28d689cb05$var$Rh & 21)) return a.baseState && (a.baseState = !1, $c79bde28d689cb05$var$Ug = !0), a.memoizedState = c;
    $c79bde28d689cb05$var$He(c, b) || (c = $c79bde28d689cb05$var$yc(), $c79bde28d689cb05$var$N.lanes |= c, $c79bde28d689cb05$var$hh |= c, a.baseState = !0);
    return b;
}
function $c79bde28d689cb05$var$Ei(a, b) {
    var c = $c79bde28d689cb05$var$C;
    $c79bde28d689cb05$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c79bde28d689cb05$var$Qh.transition;
    $c79bde28d689cb05$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$Qh.transition = d;
    }
}
function $c79bde28d689cb05$var$Fi() {
    return $c79bde28d689cb05$var$di().memoizedState;
}
function $c79bde28d689cb05$var$Gi(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, c);
    else if (c = $c79bde28d689cb05$var$Yg(a, b, c, d), null !== c) {
        var e = $c79bde28d689cb05$var$L();
        $c79bde28d689cb05$var$mh(c, a, d, e);
        $c79bde28d689cb05$var$Ji(c, b, d);
    }
}
function $c79bde28d689cb05$var$ri(a, b, c) {
    var d = $c79bde28d689cb05$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c79bde28d689cb05$var$Hi(a)) $c79bde28d689cb05$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c79bde28d689cb05$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c79bde28d689cb05$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c79bde28d689cb05$var$Yg(a, b, e, d);
        null !== c && (e = $c79bde28d689cb05$var$L(), $c79bde28d689cb05$var$mh(c, a, d, e), $c79bde28d689cb05$var$Ji(c, b, d));
    }
}
function $c79bde28d689cb05$var$Hi(a) {
    var b = a.alternate;
    return a === $c79bde28d689cb05$var$N || null !== b && b === $c79bde28d689cb05$var$N;
}
function $c79bde28d689cb05$var$Ii(a, b) {
    $c79bde28d689cb05$var$Th = $c79bde28d689cb05$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c79bde28d689cb05$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c79bde28d689cb05$var$Cc(a, c);
    }
}
var $c79bde28d689cb05$var$ai = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Q,
    useContext: $c79bde28d689cb05$var$Q,
    useEffect: $c79bde28d689cb05$var$Q,
    useImperativeHandle: $c79bde28d689cb05$var$Q,
    useInsertionEffect: $c79bde28d689cb05$var$Q,
    useLayoutEffect: $c79bde28d689cb05$var$Q,
    useMemo: $c79bde28d689cb05$var$Q,
    useReducer: $c79bde28d689cb05$var$Q,
    useRef: $c79bde28d689cb05$var$Q,
    useState: $c79bde28d689cb05$var$Q,
    useDebugValue: $c79bde28d689cb05$var$Q,
    useDeferredValue: $c79bde28d689cb05$var$Q,
    useTransition: $c79bde28d689cb05$var$Q,
    useMutableSource: $c79bde28d689cb05$var$Q,
    useSyncExternalStore: $c79bde28d689cb05$var$Q,
    useId: $c79bde28d689cb05$var$Q,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Yh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: function(a, b) {
        $c79bde28d689cb05$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c79bde28d689cb05$var$ti(4194308, 4, $c79bde28d689cb05$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c79bde28d689cb05$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c79bde28d689cb05$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c79bde28d689cb05$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c79bde28d689cb05$var$Gi.bind(null, $c79bde28d689cb05$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c79bde28d689cb05$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c79bde28d689cb05$var$qi,
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        return $c79bde28d689cb05$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$qi(!1), b = a[0];
        a = $c79bde28d689cb05$var$Ei.bind(null, a[1]);
        $c79bde28d689cb05$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c79bde28d689cb05$var$N, e = $c79bde28d689cb05$var$ci();
        if ($c79bde28d689cb05$var$I) {
            if (void 0 === c) throw Error($c79bde28d689cb05$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c79bde28d689cb05$var$R) throw Error($c79bde28d689cb05$var$p(349));
            0 !== ($c79bde28d689cb05$var$Rh & 30) || $c79bde28d689cb05$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c79bde28d689cb05$var$vi($c79bde28d689cb05$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c79bde28d689cb05$var$li(9, $c79bde28d689cb05$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c79bde28d689cb05$var$ci(), b = $c79bde28d689cb05$var$R.identifierPrefix;
        if ($c79bde28d689cb05$var$I) {
            var c = $c79bde28d689cb05$var$sg;
            var d = $c79bde28d689cb05$var$rg;
            c = (d & ~(1 << 32 - $c79bde28d689cb05$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c79bde28d689cb05$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c79bde28d689cb05$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$Zh = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$fi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$fi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
}, $c79bde28d689cb05$var$$h = {
    readContext: $c79bde28d689cb05$var$Vg,
    useCallback: $c79bde28d689cb05$var$Bi,
    useContext: $c79bde28d689cb05$var$Vg,
    useEffect: $c79bde28d689cb05$var$ji,
    useImperativeHandle: $c79bde28d689cb05$var$zi,
    useInsertionEffect: $c79bde28d689cb05$var$wi,
    useLayoutEffect: $c79bde28d689cb05$var$xi,
    useMemo: $c79bde28d689cb05$var$Ci,
    useReducer: $c79bde28d689cb05$var$gi,
    useRef: $c79bde28d689cb05$var$si,
    useState: function() {
        return $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei);
    },
    useDebugValue: $c79bde28d689cb05$var$Ai,
    useDeferredValue: function(a) {
        var b = $c79bde28d689cb05$var$di();
        return null === $c79bde28d689cb05$var$O ? b.memoizedState = a : $c79bde28d689cb05$var$Di(b, $c79bde28d689cb05$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $c79bde28d689cb05$var$gi($c79bde28d689cb05$var$ei)[0], b = $c79bde28d689cb05$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c79bde28d689cb05$var$hi,
    useSyncExternalStore: $c79bde28d689cb05$var$ii,
    useId: $c79bde28d689cb05$var$Fi,
    unstable_isNewReconciler: !1
};
function $c79bde28d689cb05$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $c79bde28d689cb05$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c79bde28d689cb05$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c79bde28d689cb05$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c79bde28d689cb05$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $c79bde28d689cb05$var$Oi(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c79bde28d689cb05$var$Pi || ($c79bde28d689cb05$var$Pi = !0, $c79bde28d689cb05$var$Qi = d);
        $c79bde28d689cb05$var$Mi(a, b);
    };
    return c;
}
function $c79bde28d689cb05$var$Ri(a, b, c) {
    c = $c79bde28d689cb05$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c79bde28d689cb05$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c79bde28d689cb05$var$Mi(a, b);
        "function" !== typeof d && (null === $c79bde28d689cb05$var$Si ? $c79bde28d689cb05$var$Si = new Set([
            this
        ]) : $c79bde28d689cb05$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c79bde28d689cb05$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c79bde28d689cb05$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $c79bde28d689cb05$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $c79bde28d689cb05$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c79bde28d689cb05$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c79bde28d689cb05$var$ch(-1, 1), b.tag = 2, $c79bde28d689cb05$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c79bde28d689cb05$var$Xi = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$Ug = !1;
function $c79bde28d689cb05$var$Yi(a, b, c, d) {
    b.child = null === a ? $c79bde28d689cb05$var$Ch(b, null, c, d) : $c79bde28d689cb05$var$Bh(b, a.child, c, d);
}
function $c79bde28d689cb05$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c79bde28d689cb05$var$Tg(b, e);
    d = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    c = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && c && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, d, e);
    return b.child;
}
function $c79bde28d689cb05$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c79bde28d689cb05$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c79bde28d689cb05$var$cj(a, b, f, d, e);
        a = $c79bde28d689cb05$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c79bde28d689cb05$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $c79bde28d689cb05$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $c79bde28d689cb05$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c79bde28d689cb05$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c79bde28d689cb05$var$Ie(f, d) && a.ref === b.ref) {
            if ($c79bde28d689cb05$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c79bde28d689cb05$var$Ug = !0);
            else return b.lanes = a.lanes, $c79bde28d689cb05$var$$i(a, b, e);
        }
    }
    return $c79bde28d689cb05$var$dj(a, b, c, d, e);
}
function $c79bde28d689cb05$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj);
            $c79bde28d689cb05$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$fj, $c79bde28d689cb05$var$gj), $c79bde28d689cb05$var$gj |= d;
    $c79bde28d689cb05$var$Yi(a, b, e, c);
    return b.child;
}
function $c79bde28d689cb05$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c79bde28d689cb05$var$dj(a, b, c, d, e) {
    var f = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current;
    f = $c79bde28d689cb05$var$Yf(b, f);
    $c79bde28d689cb05$var$Tg(b, e);
    c = $c79bde28d689cb05$var$Xh(a, b, c, d, f, e);
    d = $c79bde28d689cb05$var$bi();
    if (null !== a && !$c79bde28d689cb05$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c79bde28d689cb05$var$$i(a, b, e);
    $c79bde28d689cb05$var$I && d && $c79bde28d689cb05$var$vg(b);
    b.flags |= 1;
    $c79bde28d689cb05$var$Yi(a, b, c, e);
    return b.child;
}
function $c79bde28d689cb05$var$ij(a, b, c, d, e) {
    if ($c79bde28d689cb05$var$Zf(c)) {
        var f = !0;
        $c79bde28d689cb05$var$cg(b);
    } else f = !1;
    $c79bde28d689cb05$var$Tg(b, e);
    if (null === b.stateNode) $c79bde28d689cb05$var$jj(a, b), $c79bde28d689cb05$var$ph(b, c, d), $c79bde28d689cb05$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c79bde28d689cb05$var$Vg(l) : (l = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, l = $c79bde28d689cb05$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c79bde28d689cb05$var$qh(b, g, d, l);
        $c79bde28d689cb05$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof m && ($c79bde28d689cb05$var$kh(b, c, m, d), k = b.memoizedState), (h = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c79bde28d689cb05$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c79bde28d689cb05$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c79bde28d689cb05$var$Vg(k) : (k = $c79bde28d689cb05$var$Zf(c) ? $c79bde28d689cb05$var$Xf : $c79bde28d689cb05$var$H.current, k = $c79bde28d689cb05$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c79bde28d689cb05$var$qh(b, g, d, k);
        $c79bde28d689cb05$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $c79bde28d689cb05$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $c79bde28d689cb05$var$Wf.current || $c79bde28d689cb05$var$$g ? ("function" === typeof y && ($c79bde28d689cb05$var$kh(b, c, y, d), n = b.memoizedState), (l = $c79bde28d689cb05$var$$g || $c79bde28d689cb05$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c79bde28d689cb05$var$kj(a, b, c, d, f, e);
}
function $c79bde28d689cb05$var$kj(a, b, c, d, e, f) {
    $c79bde28d689cb05$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c79bde28d689cb05$var$dg(b, c, !1), $c79bde28d689cb05$var$$i(a, b, f);
    d = b.stateNode;
    $c79bde28d689cb05$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $c79bde28d689cb05$var$Bh(b, a.child, null, f), b.child = $c79bde28d689cb05$var$Bh(b, null, h, f)) : $c79bde28d689cb05$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $c79bde28d689cb05$var$dg(b, c, !0);
    return b.child;
}
function $c79bde28d689cb05$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c79bde28d689cb05$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c79bde28d689cb05$var$ag(a, b.context, !1);
    $c79bde28d689cb05$var$Ih(a, b.containerInfo);
}
function $c79bde28d689cb05$var$mj(a, b, c, d, e) {
    $c79bde28d689cb05$var$Ig();
    $c79bde28d689cb05$var$Jg(e);
    b.flags |= 256;
    $c79bde28d689cb05$var$Yi(a, b, c, d);
    return b.child;
}
var $c79bde28d689cb05$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c79bde28d689cb05$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c79bde28d689cb05$var$pj(a, b, c) {
    var d = b.pendingProps, e = $c79bde28d689cb05$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, e & 1);
    if (null === a) {
        $c79bde28d689cb05$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $c79bde28d689cb05$var$qj(g, d, 0, null), a = $c79bde28d689cb05$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c79bde28d689cb05$var$oj(c), b.memoizedState = $c79bde28d689cb05$var$nj, a) : $c79bde28d689cb05$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c79bde28d689cb05$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $c79bde28d689cb05$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c79bde28d689cb05$var$wh(h, f) : (f = $c79bde28d689cb05$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c79bde28d689cb05$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c79bde28d689cb05$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c79bde28d689cb05$var$rj(a, b) {
    b = $c79bde28d689cb05$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c79bde28d689cb05$var$tj(a, b, c, d) {
    null !== d && $c79bde28d689cb05$var$Jg(d);
    $c79bde28d689cb05$var$Bh(b, a.child, null, c);
    a = $c79bde28d689cb05$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c79bde28d689cb05$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(422))), $c79bde28d689cb05$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c79bde28d689cb05$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c79bde28d689cb05$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c79bde28d689cb05$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $c79bde28d689cb05$var$oj(g);
        b.memoizedState = $c79bde28d689cb05$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c79bde28d689cb05$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c79bde28d689cb05$var$p(419));
        d = $c79bde28d689cb05$var$Li(f, d, void 0);
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c79bde28d689cb05$var$Ug || h) {
        d = $c79bde28d689cb05$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c79bde28d689cb05$var$Zg(a, e), $c79bde28d689cb05$var$mh(d, a, e, -1));
        }
        $c79bde28d689cb05$var$uj();
        d = $c79bde28d689cb05$var$Li(Error($c79bde28d689cb05$var$p(421)));
        return $c79bde28d689cb05$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c79bde28d689cb05$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(e.nextSibling);
    $c79bde28d689cb05$var$xg = b;
    $c79bde28d689cb05$var$I = !0;
    $c79bde28d689cb05$var$zg = null;
    null !== a && ($c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$rg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$sg, $c79bde28d689cb05$var$og[$c79bde28d689cb05$var$pg++] = $c79bde28d689cb05$var$qg, $c79bde28d689cb05$var$rg = a.id, $c79bde28d689cb05$var$sg = a.overflow, $c79bde28d689cb05$var$qg = b);
    b = $c79bde28d689cb05$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c79bde28d689cb05$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c79bde28d689cb05$var$Sg(a.return, b, c);
}
function $c79bde28d689cb05$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c79bde28d689cb05$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c79bde28d689cb05$var$Yi(a, b, d.children, c);
    d = $c79bde28d689cb05$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c79bde28d689cb05$var$wj(a, c, b);
            else if (19 === a.tag) $c79bde28d689cb05$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c79bde28d689cb05$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c79bde28d689cb05$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c79bde28d689cb05$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c79bde28d689cb05$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $c79bde28d689cb05$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c79bde28d689cb05$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c79bde28d689cb05$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c79bde28d689cb05$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c79bde28d689cb05$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c79bde28d689cb05$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c79bde28d689cb05$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $c79bde28d689cb05$var$lj(b);
            $c79bde28d689cb05$var$Ig();
            break;
        case 5:
            $c79bde28d689cb05$var$Kh(b);
            break;
        case 1:
            $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$cg(b);
            break;
        case 4:
            $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c79bde28d689cb05$var$pj(a, b, c);
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
                a = $c79bde28d689cb05$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c79bde28d689cb05$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c79bde28d689cb05$var$ej(a, b, c);
    }
    return $c79bde28d689cb05$var$$i(a, b, c);
}
var $c79bde28d689cb05$var$Aj, $c79bde28d689cb05$var$Bj, $c79bde28d689cb05$var$Cj, $c79bde28d689cb05$var$Dj;
$c79bde28d689cb05$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c79bde28d689cb05$var$Bj = function() {};
$c79bde28d689cb05$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $c79bde28d689cb05$var$Ya(a, e);
                d = $c79bde28d689cb05$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c79bde28d689cb05$var$A({}, e, {
                    value: void 0
                });
                d = $c79bde28d689cb05$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c79bde28d689cb05$var$gb(a, e);
                d = $c79bde28d689cb05$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
        }
        $c79bde28d689cb05$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c79bde28d689cb05$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c79bde28d689cb05$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c79bde28d689cb05$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c79bde28d689cb05$var$Ej(a, b) {
    if (!$c79bde28d689cb05$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c79bde28d689cb05$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c79bde28d689cb05$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c79bde28d689cb05$var$S(b), null;
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c79bde28d689cb05$var$Jh();
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
            $c79bde28d689cb05$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c79bde28d689cb05$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null));
            $c79bde28d689cb05$var$Bj(a, b);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 5:
            $c79bde28d689cb05$var$Lh(b);
            var e = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c79bde28d689cb05$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                    $c79bde28d689cb05$var$S(b);
                    return null;
                }
                a = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    d[$c79bde28d689cb05$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $c79bde28d689cb05$var$D("cancel", d);
                            $c79bde28d689cb05$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], d);
                            break;
                        case "source":
                            $c79bde28d689cb05$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c79bde28d689cb05$var$D("error", d);
                            $c79bde28d689cb05$var$D("load", d);
                            break;
                        case "details":
                            $c79bde28d689cb05$var$D("toggle", d);
                            break;
                        case "input":
                            $c79bde28d689cb05$var$Za(d, f);
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $c79bde28d689cb05$var$D("invalid", d);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$hb(d, f), $c79bde28d689cb05$var$D("invalid", d);
                    }
                    $c79bde28d689cb05$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $c79bde28d689cb05$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c79bde28d689cb05$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$Va(d);
                            $c79bde28d689cb05$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $c79bde28d689cb05$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c79bde28d689cb05$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c79bde28d689cb05$var$Of] = b;
                    a[$c79bde28d689cb05$var$Pf] = d;
                    $c79bde28d689cb05$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c79bde28d689cb05$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c79bde28d689cb05$var$D("cancel", a);
                                $c79bde28d689cb05$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c79bde28d689cb05$var$lf.length; e++)$c79bde28d689cb05$var$D($c79bde28d689cb05$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c79bde28d689cb05$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c79bde28d689cb05$var$D("error", a);
                                $c79bde28d689cb05$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $c79bde28d689cb05$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c79bde28d689cb05$var$Za(a, d);
                                e = $c79bde28d689cb05$var$Ya(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c79bde28d689cb05$var$A({}, d, {
                                    value: void 0
                                });
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$hb(a, d);
                                e = $c79bde28d689cb05$var$gb(a, d);
                                $c79bde28d689cb05$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c79bde28d689cb05$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c79bde28d689cb05$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c79bde28d689cb05$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c79bde28d689cb05$var$ob(a, k) : "number" === typeof k && $c79bde28d689cb05$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c79bde28d689cb05$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c79bde28d689cb05$var$D("scroll", a) : null != k && $c79bde28d689cb05$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $c79bde28d689cb05$var$Va(a);
                                $c79bde28d689cb05$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c79bde28d689cb05$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c79bde28d689cb05$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c79bde28d689cb05$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c79bde28d689cb05$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c79bde28d689cb05$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c79bde28d689cb05$var$p(166));
                c = $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Gh.current);
                $c79bde28d689cb05$var$Hh($c79bde28d689cb05$var$Eh.current);
                if ($c79bde28d689cb05$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$c79bde28d689cb05$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $c79bde28d689cb05$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $c79bde28d689cb05$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$c79bde28d689cb05$var$Of] = b, b.stateNode = d;
            }
            $c79bde28d689cb05$var$S(b);
            return null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c79bde28d689cb05$var$I && null !== $c79bde28d689cb05$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c79bde28d689cb05$var$Hg(), $c79bde28d689cb05$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $c79bde28d689cb05$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c79bde28d689cb05$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c79bde28d689cb05$var$p(317));
                        f[$c79bde28d689cb05$var$Of] = b;
                    } else $c79bde28d689cb05$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $c79bde28d689cb05$var$S(b);
                    f = !1;
                } else null !== $c79bde28d689cb05$var$zg && ($c79bde28d689cb05$var$Gj($c79bde28d689cb05$var$zg), $c79bde28d689cb05$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c79bde28d689cb05$var$M.current & 1) ? 0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 3) : $c79bde28d689cb05$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c79bde28d689cb05$var$S(b);
            return null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$Bj(a, b), null === a && $c79bde28d689cb05$var$sf(b.stateNode.containerInfo), $c79bde28d689cb05$var$S(b), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), $c79bde28d689cb05$var$S(b), null;
        case 17:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), $c79bde28d689cb05$var$S(b), null;
        case 19:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            f = b.memoizedState;
            if (null === f) return $c79bde28d689cb05$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c79bde28d689cb05$var$Ej(f, !1);
                else {
                    if (0 !== $c79bde28d689cb05$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c79bde28d689cb05$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c79bde28d689cb05$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, $c79bde28d689cb05$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c79bde28d689cb05$var$B() > $c79bde28d689cb05$var$Hj && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c79bde28d689cb05$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $c79bde28d689cb05$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c79bde28d689cb05$var$I) return $c79bde28d689cb05$var$S(b), null;
                    } else 2 * $c79bde28d689cb05$var$B() - f.renderingStartTime > $c79bde28d689cb05$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $c79bde28d689cb05$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c79bde28d689cb05$var$B(), b.sibling = null, c = $c79bde28d689cb05$var$M.current, $c79bde28d689cb05$var$G($c79bde28d689cb05$var$M, d ? c & 1 | 2 : c & 1), b;
            $c79bde28d689cb05$var$S(b);
            return null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c79bde28d689cb05$var$gj & 1073741824) && ($c79bde28d689cb05$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c79bde28d689cb05$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
}
function $c79bde28d689cb05$var$Jj(a, b) {
    $c79bde28d689cb05$var$wg(b);
    switch(b.tag){
        case 1:
            return $c79bde28d689cb05$var$Zf(b.type) && $c79bde28d689cb05$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $c79bde28d689cb05$var$Jh(), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf), $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H), $c79bde28d689cb05$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c79bde28d689cb05$var$Lh(b), null;
        case 13:
            $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c79bde28d689cb05$var$p(340));
                $c79bde28d689cb05$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M), null;
        case 4:
            return $c79bde28d689cb05$var$Jh(), null;
        case 10:
            return $c79bde28d689cb05$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $c79bde28d689cb05$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c79bde28d689cb05$var$Kj = !1, $c79bde28d689cb05$var$U = !1, $c79bde28d689cb05$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $c79bde28d689cb05$var$V = null;
function $c79bde28d689cb05$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $c79bde28d689cb05$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c79bde28d689cb05$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $c79bde28d689cb05$var$W(a, b, d);
    }
}
var $c79bde28d689cb05$var$Oj = !1;
function $c79bde28d689cb05$var$Pj(a, b) {
    $c79bde28d689cb05$var$Cf = $c79bde28d689cb05$var$dd;
    a = $c79bde28d689cb05$var$Me();
    if ($c79bde28d689cb05$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c79bde28d689cb05$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $c79bde28d689cb05$var$dd = !1;
    for($c79bde28d689cb05$var$V = b; null !== $c79bde28d689cb05$var$V;)if (b = $c79bde28d689cb05$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c79bde28d689cb05$var$V = a;
    else for(; null !== $c79bde28d689cb05$var$V;){
        b = $c79bde28d689cb05$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $c79bde28d689cb05$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(163));
            }
        } catch (F) {
            $c79bde28d689cb05$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c79bde28d689cb05$var$V = a;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
    n = $c79bde28d689cb05$var$Oj;
    $c79bde28d689cb05$var$Oj = !1;
    return n;
}
function $c79bde28d689cb05$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $c79bde28d689cb05$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c79bde28d689cb05$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $c79bde28d689cb05$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $c79bde28d689cb05$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c79bde28d689cb05$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c79bde28d689cb05$var$Of], delete b[$c79bde28d689cb05$var$Pf], delete b[$c79bde28d689cb05$var$of], delete b[$c79bde28d689cb05$var$Qf], delete b[$c79bde28d689cb05$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c79bde28d689cb05$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c79bde28d689cb05$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c79bde28d689cb05$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c79bde28d689cb05$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c79bde28d689cb05$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Wj(a, b, c), a = a.sibling;
}
function $c79bde28d689cb05$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling; null !== a;)$c79bde28d689cb05$var$Xj(a, b, c), a = a.sibling;
}
var $c79bde28d689cb05$var$X = null, $c79bde28d689cb05$var$Yj = !1;
function $c79bde28d689cb05$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$c79bde28d689cb05$var$ak(a, b, c), c = c.sibling;
}
function $c79bde28d689cb05$var$ak(a, b, c) {
    if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onCommitFiberUnmount) try {
        $c79bde28d689cb05$var$lc.onCommitFiberUnmount($c79bde28d689cb05$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Mj(c, b);
        case 6:
            var d = $c79bde28d689cb05$var$X, e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c79bde28d689cb05$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c79bde28d689cb05$var$X && ($c79bde28d689cb05$var$Yj ? (a = $c79bde28d689cb05$var$X, c = c.stateNode, 8 === a.nodeType ? $c79bde28d689cb05$var$Kf(a.parentNode, c) : 1 === a.nodeType && $c79bde28d689cb05$var$Kf(a, c), $c79bde28d689cb05$var$bd(a)) : $c79bde28d689cb05$var$Kf($c79bde28d689cb05$var$X, c.stateNode));
            break;
        case 4:
            d = $c79bde28d689cb05$var$X;
            e = $c79bde28d689cb05$var$Yj;
            $c79bde28d689cb05$var$X = c.stateNode.containerInfo;
            $c79bde28d689cb05$var$Yj = !0;
            $c79bde28d689cb05$var$Zj(a, b, c);
            $c79bde28d689cb05$var$X = d;
            $c79bde28d689cb05$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c79bde28d689cb05$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c79bde28d689cb05$var$Nj(c, b, g) : 0 !== (f & 4) && $c79bde28d689cb05$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 1:
            if (!$c79bde28d689cb05$var$U && ($c79bde28d689cb05$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $c79bde28d689cb05$var$W(c, b, h);
            }
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 21:
            $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c79bde28d689cb05$var$U = (d = $c79bde28d689cb05$var$U) || null !== c.memoizedState, $c79bde28d689cb05$var$Zj(a, b, c), $c79bde28d689cb05$var$U = d) : $c79bde28d689cb05$var$Zj(a, b, c);
            break;
        default:
            $c79bde28d689cb05$var$Zj(a, b, c);
    }
}
function $c79bde28d689cb05$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c79bde28d689cb05$var$Lj);
        b.forEach(function(b) {
            var d = $c79bde28d689cb05$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $c79bde28d689cb05$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c79bde28d689cb05$var$X = h.stateNode;
                        $c79bde28d689cb05$var$Yj = !1;
                        break a;
                    case 3:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                    case 4:
                        $c79bde28d689cb05$var$X = h.stateNode.containerInfo;
                        $c79bde28d689cb05$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c79bde28d689cb05$var$X) throw Error($c79bde28d689cb05$var$p(160));
            $c79bde28d689cb05$var$ak(f, g, e);
            $c79bde28d689cb05$var$X = null;
            $c79bde28d689cb05$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c79bde28d689cb05$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c79bde28d689cb05$var$ek(b, a), b = b.sibling;
}
function $c79bde28d689cb05$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                try {
                    $c79bde28d689cb05$var$Qj(3, a, a.return), $c79bde28d689cb05$var$Rj(3, a);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
                try {
                    $c79bde28d689cb05$var$Qj(5, a, a.return);
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            break;
        case 5:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 512 && null !== c && $c79bde28d689cb05$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c79bde28d689cb05$var$ob(e, "");
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c79bde28d689cb05$var$ab(e, f);
                    $c79bde28d689cb05$var$vb(h, g);
                    var l = $c79bde28d689cb05$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $c79bde28d689cb05$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $c79bde28d689cb05$var$nb(e, q) : "children" === m ? $c79bde28d689cb05$var$ob(e, q) : $c79bde28d689cb05$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $c79bde28d689cb05$var$bb(e, f);
                            break;
                        case "textarea":
                            $c79bde28d689cb05$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $c79bde28d689cb05$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c79bde28d689cb05$var$fb(e, !!f.multiple, f.defaultValue, !0) : $c79bde28d689cb05$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c79bde28d689cb05$var$Pf] = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c79bde28d689cb05$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $c79bde28d689cb05$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c79bde28d689cb05$var$bd(b.containerInfo);
            } catch (t) {
                $c79bde28d689cb05$var$W(a, a.return, t);
            }
            break;
        case 4:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            break;
        case 13:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c79bde28d689cb05$var$gk = $c79bde28d689cb05$var$B()));
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c79bde28d689cb05$var$U = (l = $c79bde28d689cb05$var$U) || m, $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$U = l) : $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($c79bde28d689cb05$var$V = a, m = a.child; null !== m;){
                    for(q = $c79bde28d689cb05$var$V = m; null !== $c79bde28d689cb05$var$V;){
                        r = $c79bde28d689cb05$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $c79bde28d689cb05$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $c79bde28d689cb05$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $c79bde28d689cb05$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c79bde28d689cb05$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $c79bde28d689cb05$var$V = y) : $c79bde28d689cb05$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c79bde28d689cb05$var$rb("display", g));
                            } catch (t) {
                                $c79bde28d689cb05$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $c79bde28d689cb05$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c79bde28d689cb05$var$dk(b, a);
            $c79bde28d689cb05$var$fk(a);
            d & 4 && $c79bde28d689cb05$var$bk(a);
            break;
        case 21:
            break;
        default:
            $c79bde28d689cb05$var$dk(b, a), $c79bde28d689cb05$var$fk(a);
    }
}
function $c79bde28d689cb05$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c79bde28d689cb05$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c79bde28d689cb05$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c79bde28d689cb05$var$ob(e, ""), d.flags &= -33);
                    var f = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c79bde28d689cb05$var$Vj(a);
                    $c79bde28d689cb05$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(161));
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c79bde28d689cb05$var$ik(a, b, c) {
    $c79bde28d689cb05$var$V = a;
    $c79bde28d689cb05$var$jk(a, b, c);
}
function $c79bde28d689cb05$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c79bde28d689cb05$var$V;){
        var e = $c79bde28d689cb05$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c79bde28d689cb05$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c79bde28d689cb05$var$U;
                h = $c79bde28d689cb05$var$Kj;
                var l = $c79bde28d689cb05$var$U;
                $c79bde28d689cb05$var$Kj = g;
                if (($c79bde28d689cb05$var$U = k) && !l) for($c79bde28d689cb05$var$V = e; null !== $c79bde28d689cb05$var$V;)g = $c79bde28d689cb05$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c79bde28d689cb05$var$kk(e) : null !== k ? (k.return = g, $c79bde28d689cb05$var$V = k) : $c79bde28d689cb05$var$kk(e);
                for(; null !== f;)$c79bde28d689cb05$var$V = f, $c79bde28d689cb05$var$jk(f, b, c), f = f.sibling;
                $c79bde28d689cb05$var$V = e;
                $c79bde28d689cb05$var$Kj = h;
                $c79bde28d689cb05$var$U = l;
            }
            $c79bde28d689cb05$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c79bde28d689cb05$var$V = f) : $c79bde28d689cb05$var$lk(a, b, c);
    }
}
function $c79bde28d689cb05$var$lk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $c79bde28d689cb05$var$U || $c79bde28d689cb05$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c79bde28d689cb05$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c79bde28d689cb05$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $c79bde28d689cb05$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $c79bde28d689cb05$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $c79bde28d689cb05$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c79bde28d689cb05$var$p(163));
                }
                $c79bde28d689cb05$var$U || b.flags & 512 && $c79bde28d689cb05$var$Sj(b);
            } catch (r) {
                $c79bde28d689cb05$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$hk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c79bde28d689cb05$var$V = c;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
function $c79bde28d689cb05$var$kk(a) {
    for(; null !== $c79bde28d689cb05$var$V;){
        var b = $c79bde28d689cb05$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $c79bde28d689cb05$var$Rj(4, b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $c79bde28d689cb05$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $c79bde28d689cb05$var$Sj(b);
                    } catch (k) {
                        $c79bde28d689cb05$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $c79bde28d689cb05$var$W(b, b.return, k);
        }
        if (b === a) {
            $c79bde28d689cb05$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $c79bde28d689cb05$var$V = h;
            break;
        }
        $c79bde28d689cb05$var$V = b.return;
    }
}
var $c79bde28d689cb05$var$mk = Math.ceil, $c79bde28d689cb05$var$nk = $c79bde28d689cb05$var$ua.ReactCurrentDispatcher, $c79bde28d689cb05$var$ok = $c79bde28d689cb05$var$ua.ReactCurrentOwner, $c79bde28d689cb05$var$pk = $c79bde28d689cb05$var$ua.ReactCurrentBatchConfig, $c79bde28d689cb05$var$K = 0, $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Y = null, $c79bde28d689cb05$var$Z = 0, $c79bde28d689cb05$var$gj = 0, $c79bde28d689cb05$var$fj = $c79bde28d689cb05$var$Uf(0), $c79bde28d689cb05$var$T = 0, $c79bde28d689cb05$var$qk = null, $c79bde28d689cb05$var$hh = 0, $c79bde28d689cb05$var$rk = 0, $c79bde28d689cb05$var$sk = 0, $c79bde28d689cb05$var$tk = null, $c79bde28d689cb05$var$uk = null, $c79bde28d689cb05$var$gk = 0, $c79bde28d689cb05$var$Hj = Infinity, $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Pi = !1, $c79bde28d689cb05$var$Qi = null, $c79bde28d689cb05$var$Si = null, $c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = null, $c79bde28d689cb05$var$yk = 0, $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, $c79bde28d689cb05$var$Bk = -1, $c79bde28d689cb05$var$Ck = 0;
function $c79bde28d689cb05$var$L() {
    return 0 !== ($c79bde28d689cb05$var$K & 6) ? $c79bde28d689cb05$var$B() : -1 !== $c79bde28d689cb05$var$Bk ? $c79bde28d689cb05$var$Bk : $c79bde28d689cb05$var$Bk = $c79bde28d689cb05$var$B();
}
function $c79bde28d689cb05$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c79bde28d689cb05$var$K & 2) && 0 !== $c79bde28d689cb05$var$Z) return $c79bde28d689cb05$var$Z & -$c79bde28d689cb05$var$Z;
    if (null !== $c79bde28d689cb05$var$Kg.transition) return 0 === $c79bde28d689cb05$var$Ck && ($c79bde28d689cb05$var$Ck = $c79bde28d689cb05$var$yc()), $c79bde28d689cb05$var$Ck;
    a = $c79bde28d689cb05$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c79bde28d689cb05$var$jd(a.type);
    return a;
}
function $c79bde28d689cb05$var$mh(a, b, c, d) {
    if (50 < $c79bde28d689cb05$var$zk) throw $c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = null, Error($c79bde28d689cb05$var$p(185));
    $c79bde28d689cb05$var$Ac(a, c, d);
    if (0 === ($c79bde28d689cb05$var$K & 2) || a !== $c79bde28d689cb05$var$R) a === $c79bde28d689cb05$var$R && (0 === ($c79bde28d689cb05$var$K & 2) && ($c79bde28d689cb05$var$rk |= c), 4 === $c79bde28d689cb05$var$T && $c79bde28d689cb05$var$Dk(a, $c79bde28d689cb05$var$Z)), $c79bde28d689cb05$var$Ek(a, d), 1 === c && 0 === $c79bde28d689cb05$var$K && 0 === (b.mode & 1) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
}
function $c79bde28d689cb05$var$Ek(a, b) {
    var c = a.callbackNode;
    $c79bde28d689cb05$var$wc(a, b);
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) null !== c && $c79bde28d689cb05$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c79bde28d689cb05$var$bc(c);
        if (1 === b) 0 === a.tag ? $c79bde28d689cb05$var$ig($c79bde28d689cb05$var$Fk.bind(null, a)) : $c79bde28d689cb05$var$hg($c79bde28d689cb05$var$Fk.bind(null, a)), $c79bde28d689cb05$var$Jf(function() {
            0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
        }), c = null;
        else {
            switch($c79bde28d689cb05$var$Dc(d)){
                case 1:
                    c = $c79bde28d689cb05$var$fc;
                    break;
                case 4:
                    c = $c79bde28d689cb05$var$gc;
                    break;
                case 16:
                    c = $c79bde28d689cb05$var$hc;
                    break;
                case 536870912:
                    c = $c79bde28d689cb05$var$jc;
                    break;
                default:
                    c = $c79bde28d689cb05$var$hc;
            }
            c = $c79bde28d689cb05$var$Gk(c, $c79bde28d689cb05$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c79bde28d689cb05$var$Hk(a, b) {
    $c79bde28d689cb05$var$Bk = -1;
    $c79bde28d689cb05$var$Ck = 0;
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    var c = a.callbackNode;
    if ($c79bde28d689cb05$var$Ik() && a.callbackNode !== c) return null;
    var d = $c79bde28d689cb05$var$uc(a, a === $c79bde28d689cb05$var$R ? $c79bde28d689cb05$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c79bde28d689cb05$var$Jk(a, d);
    else {
        b = d;
        var e = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 2;
        var f = $c79bde28d689cb05$var$Kk();
        if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$Lk(a, b);
        for(;;)try {
            $c79bde28d689cb05$var$Mk();
            break;
        } catch (h) {
            $c79bde28d689cb05$var$Nk(a, h);
        }
        $c79bde28d689cb05$var$Qg();
        $c79bde28d689cb05$var$nk.current = f;
        $c79bde28d689cb05$var$K = e;
        null !== $c79bde28d689cb05$var$Y ? b = 0 : ($c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0, b = $c79bde28d689cb05$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c79bde28d689cb05$var$xc(a), 0 !== e && (d = e, b = $c79bde28d689cb05$var$Ok(a, e)));
        if (1 === b) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
        if (6 === b) $c79bde28d689cb05$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c79bde28d689cb05$var$Pk(e) && (b = $c79bde28d689cb05$var$Jk(a, d), 2 === b && (f = $c79bde28d689cb05$var$xc(a), 0 !== f && (d = f, b = $c79bde28d689cb05$var$Ok(a, f))), 1 === b)) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, d), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c79bde28d689cb05$var$p(345));
                case 2:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 3:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $c79bde28d689cb05$var$gk + 500 - $c79bde28d689cb05$var$B(), 10 < b)) {
                        if (0 !== $c79bde28d689cb05$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c79bde28d689cb05$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), b);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 4:
                    $c79bde28d689cb05$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $c79bde28d689cb05$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $c79bde28d689cb05$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c79bde28d689cb05$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c79bde28d689cb05$var$Ff($c79bde28d689cb05$var$Qk.bind(null, a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk), d);
                        break;
                    }
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                case 5:
                    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
                    break;
                default:
                    throw Error($c79bde28d689cb05$var$p(329));
            }
        }
    }
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return a.callbackNode === c ? $c79bde28d689cb05$var$Hk.bind(null, a) : null;
}
function $c79bde28d689cb05$var$Ok(a, b) {
    var c = $c79bde28d689cb05$var$tk;
    a.current.memoizedState.isDehydrated && ($c79bde28d689cb05$var$Lk(a, b).flags |= 256);
    a = $c79bde28d689cb05$var$Jk(a, b);
    2 !== a && (b = $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$uk = c, null !== b && $c79bde28d689cb05$var$Gj(b));
    return a;
}
function $c79bde28d689cb05$var$Gj(a) {
    null === $c79bde28d689cb05$var$uk ? $c79bde28d689cb05$var$uk = a : $c79bde28d689cb05$var$uk.push.apply($c79bde28d689cb05$var$uk, a);
}
function $c79bde28d689cb05$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c79bde28d689cb05$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c79bde28d689cb05$var$Dk(a, b) {
    b &= ~$c79bde28d689cb05$var$sk;
    b &= ~$c79bde28d689cb05$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c79bde28d689cb05$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c79bde28d689cb05$var$Fk(a) {
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$uc(a, 0);
    if (0 === (b & 1)) return $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), null;
    var c = $c79bde28d689cb05$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c79bde28d689cb05$var$xc(a);
        0 !== d && (b = d, c = $c79bde28d689cb05$var$Ok(a, d));
    }
    if (1 === c) throw c = $c79bde28d689cb05$var$qk, $c79bde28d689cb05$var$Lk(a, 0), $c79bde28d689cb05$var$Dk(a, b), $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B()), c;
    if (6 === c) throw Error($c79bde28d689cb05$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c79bde28d689cb05$var$Qk(a, $c79bde28d689cb05$var$uk, $c79bde28d689cb05$var$vk);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    return null;
}
function $c79bde28d689cb05$var$Rk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c79bde28d689cb05$var$K = c, 0 === $c79bde28d689cb05$var$K && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$fg && $c79bde28d689cb05$var$jg());
    }
}
function $c79bde28d689cb05$var$Sk(a) {
    null !== $c79bde28d689cb05$var$xk && 0 === $c79bde28d689cb05$var$xk.tag && 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$Ik();
    var b = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 1;
    var c = $c79bde28d689cb05$var$pk.transition, d = $c79bde28d689cb05$var$C;
    try {
        if ($c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, a) return a();
    } finally{
        $c79bde28d689cb05$var$C = d, $c79bde28d689cb05$var$pk.transition = c, $c79bde28d689cb05$var$K = b, 0 === ($c79bde28d689cb05$var$K & 6) && $c79bde28d689cb05$var$jg();
    }
}
function $c79bde28d689cb05$var$Ij() {
    $c79bde28d689cb05$var$gj = $c79bde28d689cb05$var$fj.current;
    $c79bde28d689cb05$var$E($c79bde28d689cb05$var$fj);
}
function $c79bde28d689cb05$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c79bde28d689cb05$var$Gf(c));
    if (null !== $c79bde28d689cb05$var$Y) for(c = $c79bde28d689cb05$var$Y.return; null !== c;){
        var d = c;
        $c79bde28d689cb05$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c79bde28d689cb05$var$$f();
                break;
            case 3:
                $c79bde28d689cb05$var$Jh();
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$Wf);
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$H);
                $c79bde28d689cb05$var$Oh();
                break;
            case 5:
                $c79bde28d689cb05$var$Lh(d);
                break;
            case 4:
                $c79bde28d689cb05$var$Jh();
                break;
            case 13:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 19:
                $c79bde28d689cb05$var$E($c79bde28d689cb05$var$M);
                break;
            case 10:
                $c79bde28d689cb05$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $c79bde28d689cb05$var$Ij();
        }
        c = c.return;
    }
    $c79bde28d689cb05$var$R = a;
    $c79bde28d689cb05$var$Y = a = $c79bde28d689cb05$var$wh(a.current, null);
    $c79bde28d689cb05$var$Z = $c79bde28d689cb05$var$gj = b;
    $c79bde28d689cb05$var$T = 0;
    $c79bde28d689cb05$var$qk = null;
    $c79bde28d689cb05$var$sk = $c79bde28d689cb05$var$rk = $c79bde28d689cb05$var$hh = 0;
    $c79bde28d689cb05$var$uk = $c79bde28d689cb05$var$tk = null;
    if (null !== $c79bde28d689cb05$var$Wg) {
        for(b = 0; b < $c79bde28d689cb05$var$Wg.length; b++)if (c = $c79bde28d689cb05$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c79bde28d689cb05$var$Wg = null;
    }
    return a;
}
function $c79bde28d689cb05$var$Nk(a, b) {
    do {
        var c = $c79bde28d689cb05$var$Y;
        try {
            $c79bde28d689cb05$var$Qg();
            $c79bde28d689cb05$var$Ph.current = $c79bde28d689cb05$var$ai;
            if ($c79bde28d689cb05$var$Sh) {
                for(var d = $c79bde28d689cb05$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c79bde28d689cb05$var$Sh = !1;
            }
            $c79bde28d689cb05$var$Rh = 0;
            $c79bde28d689cb05$var$P = $c79bde28d689cb05$var$O = $c79bde28d689cb05$var$N = null;
            $c79bde28d689cb05$var$Th = !1;
            $c79bde28d689cb05$var$Uh = 0;
            $c79bde28d689cb05$var$ok.current = null;
            if (null === c || null === c.return) {
                $c79bde28d689cb05$var$T = 1;
                $c79bde28d689cb05$var$qk = b;
                $c79bde28d689cb05$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $c79bde28d689cb05$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $c79bde28d689cb05$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $c79bde28d689cb05$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $c79bde28d689cb05$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c79bde28d689cb05$var$Ti(f, l, b);
                            $c79bde28d689cb05$var$uj();
                            break a;
                        }
                        k = Error($c79bde28d689cb05$var$p(426));
                    }
                } else if ($c79bde28d689cb05$var$I && h.mode & 1) {
                    var J = $c79bde28d689cb05$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $c79bde28d689cb05$var$Wi(J, g, h, f, b);
                        $c79bde28d689cb05$var$Jg($c79bde28d689cb05$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $c79bde28d689cb05$var$Ki(k, h);
                4 !== $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 2);
                null === $c79bde28d689cb05$var$tk ? $c79bde28d689cb05$var$tk = [
                    f
                ] : $c79bde28d689cb05$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $c79bde28d689cb05$var$Oi(f, k, b);
                            $c79bde28d689cb05$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $c79bde28d689cb05$var$Ri(f, h, b);
                                $c79bde28d689cb05$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $c79bde28d689cb05$var$Tk(c);
        } catch (na) {
            b = na;
            $c79bde28d689cb05$var$Y === c && null !== c && ($c79bde28d689cb05$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c79bde28d689cb05$var$Kk() {
    var a = $c79bde28d689cb05$var$nk.current;
    $c79bde28d689cb05$var$nk.current = $c79bde28d689cb05$var$ai;
    return null === a ? $c79bde28d689cb05$var$ai : a;
}
function $c79bde28d689cb05$var$uj() {
    if (0 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T || 2 === $c79bde28d689cb05$var$T) $c79bde28d689cb05$var$T = 4;
    null === $c79bde28d689cb05$var$R || 0 === ($c79bde28d689cb05$var$hh & 268435455) && 0 === ($c79bde28d689cb05$var$rk & 268435455) || $c79bde28d689cb05$var$Dk($c79bde28d689cb05$var$R, $c79bde28d689cb05$var$Z);
}
function $c79bde28d689cb05$var$Jk(a, b) {
    var c = $c79bde28d689cb05$var$K;
    $c79bde28d689cb05$var$K |= 2;
    var d = $c79bde28d689cb05$var$Kk();
    if ($c79bde28d689cb05$var$R !== a || $c79bde28d689cb05$var$Z !== b) $c79bde28d689cb05$var$vk = null, $c79bde28d689cb05$var$Lk(a, b);
    for(;;)try {
        $c79bde28d689cb05$var$Uk();
        break;
    } catch (e) {
        $c79bde28d689cb05$var$Nk(a, e);
    }
    $c79bde28d689cb05$var$Qg();
    $c79bde28d689cb05$var$K = c;
    $c79bde28d689cb05$var$nk.current = d;
    if (null !== $c79bde28d689cb05$var$Y) throw Error($c79bde28d689cb05$var$p(261));
    $c79bde28d689cb05$var$R = null;
    $c79bde28d689cb05$var$Z = 0;
    return $c79bde28d689cb05$var$T;
}
function $c79bde28d689cb05$var$Uk() {
    for(; null !== $c79bde28d689cb05$var$Y;)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Mk() {
    for(; null !== $c79bde28d689cb05$var$Y && !$c79bde28d689cb05$var$cc();)$c79bde28d689cb05$var$Vk($c79bde28d689cb05$var$Y);
}
function $c79bde28d689cb05$var$Vk(a) {
    var b = $c79bde28d689cb05$var$Wk(a.alternate, a, $c79bde28d689cb05$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c79bde28d689cb05$var$Tk(a) : $c79bde28d689cb05$var$Y = b;
    $c79bde28d689cb05$var$ok.current = null;
}
function $c79bde28d689cb05$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $c79bde28d689cb05$var$Fj(c, b, $c79bde28d689cb05$var$gj), null !== c) {
                $c79bde28d689cb05$var$Y = c;
                return;
            }
        } else {
            c = $c79bde28d689cb05$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c79bde28d689cb05$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c79bde28d689cb05$var$T = 6;
                $c79bde28d689cb05$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c79bde28d689cb05$var$Y = b;
            return;
        }
        $c79bde28d689cb05$var$Y = b = a;
    }while (null !== b);
    0 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$T = 5);
}
function $c79bde28d689cb05$var$Qk(a, b, c) {
    var d = $c79bde28d689cb05$var$C, e = $c79bde28d689cb05$var$pk.transition;
    try {
        $c79bde28d689cb05$var$pk.transition = null, $c79bde28d689cb05$var$C = 1, $c79bde28d689cb05$var$Xk(a, b, c, d);
    } finally{
        $c79bde28d689cb05$var$pk.transition = e, $c79bde28d689cb05$var$C = d;
    }
    return null;
}
function $c79bde28d689cb05$var$Xk(a, b, c, d) {
    do $c79bde28d689cb05$var$Ik();
    while (null !== $c79bde28d689cb05$var$xk);
    if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c79bde28d689cb05$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c79bde28d689cb05$var$Bc(a, f);
    a === $c79bde28d689cb05$var$R && ($c79bde28d689cb05$var$Y = $c79bde28d689cb05$var$R = null, $c79bde28d689cb05$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c79bde28d689cb05$var$wk || ($c79bde28d689cb05$var$wk = !0, $c79bde28d689cb05$var$Gk($c79bde28d689cb05$var$hc, function() {
        $c79bde28d689cb05$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c79bde28d689cb05$var$pk.transition;
        $c79bde28d689cb05$var$pk.transition = null;
        var g = $c79bde28d689cb05$var$C;
        $c79bde28d689cb05$var$C = 1;
        var h = $c79bde28d689cb05$var$K;
        $c79bde28d689cb05$var$K |= 4;
        $c79bde28d689cb05$var$ok.current = null;
        $c79bde28d689cb05$var$Pj(a, c);
        $c79bde28d689cb05$var$ek(c, a);
        $c79bde28d689cb05$var$Oe($c79bde28d689cb05$var$Df);
        $c79bde28d689cb05$var$dd = !!$c79bde28d689cb05$var$Cf;
        $c79bde28d689cb05$var$Df = $c79bde28d689cb05$var$Cf = null;
        a.current = c;
        $c79bde28d689cb05$var$ik(c, a, e);
        $c79bde28d689cb05$var$dc();
        $c79bde28d689cb05$var$K = h;
        $c79bde28d689cb05$var$C = g;
        $c79bde28d689cb05$var$pk.transition = f;
    } else a.current = c;
    $c79bde28d689cb05$var$wk && ($c79bde28d689cb05$var$wk = !1, $c79bde28d689cb05$var$xk = a, $c79bde28d689cb05$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($c79bde28d689cb05$var$Si = null);
    $c79bde28d689cb05$var$mc(c.stateNode, d);
    $c79bde28d689cb05$var$Ek(a, $c79bde28d689cb05$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c79bde28d689cb05$var$Pi) throw $c79bde28d689cb05$var$Pi = !1, a = $c79bde28d689cb05$var$Qi, $c79bde28d689cb05$var$Qi = null, a;
    0 !== ($c79bde28d689cb05$var$yk & 1) && 0 !== a.tag && $c79bde28d689cb05$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $c79bde28d689cb05$var$Ak ? $c79bde28d689cb05$var$zk++ : ($c79bde28d689cb05$var$zk = 0, $c79bde28d689cb05$var$Ak = a) : $c79bde28d689cb05$var$zk = 0;
    $c79bde28d689cb05$var$jg();
    return null;
}
function $c79bde28d689cb05$var$Ik() {
    if (null !== $c79bde28d689cb05$var$xk) {
        var a = $c79bde28d689cb05$var$Dc($c79bde28d689cb05$var$yk), b = $c79bde28d689cb05$var$pk.transition, c = $c79bde28d689cb05$var$C;
        try {
            $c79bde28d689cb05$var$pk.transition = null;
            $c79bde28d689cb05$var$C = 16 > a ? 16 : a;
            if (null === $c79bde28d689cb05$var$xk) var d = !1;
            else {
                a = $c79bde28d689cb05$var$xk;
                $c79bde28d689cb05$var$xk = null;
                $c79bde28d689cb05$var$yk = 0;
                if (0 !== ($c79bde28d689cb05$var$K & 6)) throw Error($c79bde28d689cb05$var$p(331));
                var e = $c79bde28d689cb05$var$K;
                $c79bde28d689cb05$var$K |= 4;
                for($c79bde28d689cb05$var$V = a.current; null !== $c79bde28d689cb05$var$V;){
                    var f = $c79bde28d689cb05$var$V, g = f.child;
                    if (0 !== ($c79bde28d689cb05$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c79bde28d689cb05$var$V = l; null !== $c79bde28d689cb05$var$V;){
                                    var m = $c79bde28d689cb05$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $c79bde28d689cb05$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $c79bde28d689cb05$var$V = q;
                                    else for(; null !== $c79bde28d689cb05$var$V;){
                                        m = $c79bde28d689cb05$var$V;
                                        var r = m.sibling, y = m.return;
                                        $c79bde28d689cb05$var$Tj(m);
                                        if (m === l) {
                                            $c79bde28d689cb05$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $c79bde28d689cb05$var$V = r;
                                            break;
                                        }
                                        $c79bde28d689cb05$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $c79bde28d689cb05$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c79bde28d689cb05$var$V = g;
                    else b: for(; null !== $c79bde28d689cb05$var$V;){
                        f = $c79bde28d689cb05$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $c79bde28d689cb05$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $c79bde28d689cb05$var$V = x;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = f.return;
                    }
                }
                var w = a.current;
                for($c79bde28d689cb05$var$V = w; null !== $c79bde28d689cb05$var$V;){
                    g = $c79bde28d689cb05$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $c79bde28d689cb05$var$V = u;
                    else b: for(g = w; null !== $c79bde28d689cb05$var$V;){
                        h = $c79bde28d689cb05$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $c79bde28d689cb05$var$Rj(9, h);
                            }
                        } catch (na) {
                            $c79bde28d689cb05$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $c79bde28d689cb05$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $c79bde28d689cb05$var$V = F;
                            break b;
                        }
                        $c79bde28d689cb05$var$V = h.return;
                    }
                }
                $c79bde28d689cb05$var$K = e;
                $c79bde28d689cb05$var$jg();
                if ($c79bde28d689cb05$var$lc && "function" === typeof $c79bde28d689cb05$var$lc.onPostCommitFiberRoot) try {
                    $c79bde28d689cb05$var$lc.onPostCommitFiberRoot($c79bde28d689cb05$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $c79bde28d689cb05$var$C = c, $c79bde28d689cb05$var$pk.transition = b;
        }
    }
    return !1;
}
function $c79bde28d689cb05$var$Yk(a, b, c) {
    b = $c79bde28d689cb05$var$Ki(c, b);
    b = $c79bde28d689cb05$var$Oi(a, b, 1);
    a = $c79bde28d689cb05$var$dh(a, b, 1);
    b = $c79bde28d689cb05$var$L();
    null !== a && ($c79bde28d689cb05$var$Ac(a, 1, b), $c79bde28d689cb05$var$Ek(a, b));
}
function $c79bde28d689cb05$var$W(a, b, c) {
    if (3 === a.tag) $c79bde28d689cb05$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c79bde28d689cb05$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c79bde28d689cb05$var$Si || !$c79bde28d689cb05$var$Si.has(d))) {
                a = $c79bde28d689cb05$var$Ki(c, a);
                a = $c79bde28d689cb05$var$Ri(b, a, 1);
                b = $c79bde28d689cb05$var$dh(b, a, 1);
                a = $c79bde28d689cb05$var$L();
                null !== b && ($c79bde28d689cb05$var$Ac(b, 1, a), $c79bde28d689cb05$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c79bde28d689cb05$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c79bde28d689cb05$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $c79bde28d689cb05$var$R === a && ($c79bde28d689cb05$var$Z & c) === c && (4 === $c79bde28d689cb05$var$T || 3 === $c79bde28d689cb05$var$T && ($c79bde28d689cb05$var$Z & 130023424) === $c79bde28d689cb05$var$Z && 500 > $c79bde28d689cb05$var$B() - $c79bde28d689cb05$var$gk ? $c79bde28d689cb05$var$Lk(a, 0) : $c79bde28d689cb05$var$sk |= c);
    $c79bde28d689cb05$var$Ek(a, b);
}
function $c79bde28d689cb05$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c79bde28d689cb05$var$sc, $c79bde28d689cb05$var$sc <<= 1, 0 === ($c79bde28d689cb05$var$sc & 130023424) && ($c79bde28d689cb05$var$sc = 4194304)));
    var c = $c79bde28d689cb05$var$L();
    a = $c79bde28d689cb05$var$Zg(a, b);
    null !== a && ($c79bde28d689cb05$var$Ac(a, b, c), $c79bde28d689cb05$var$Ek(a, c));
}
function $c79bde28d689cb05$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c79bde28d689cb05$var$Zk(a, c);
}
function $c79bde28d689cb05$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c79bde28d689cb05$var$p(314));
    }
    null !== d && d.delete(b);
    $c79bde28d689cb05$var$Zk(a, c);
}
var $c79bde28d689cb05$var$Wk;
$c79bde28d689cb05$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c79bde28d689cb05$var$Wf.current) $c79bde28d689cb05$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$zj(a, b, c);
            $c79bde28d689cb05$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c79bde28d689cb05$var$Ug = !1, $c79bde28d689cb05$var$I && 0 !== (b.flags & 1048576) && $c79bde28d689cb05$var$ug(b, $c79bde28d689cb05$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c79bde28d689cb05$var$jj(a, b);
            a = b.pendingProps;
            var e = $c79bde28d689cb05$var$Yf(b, $c79bde28d689cb05$var$H.current);
            $c79bde28d689cb05$var$Tg(b, c);
            e = $c79bde28d689cb05$var$Xh(null, b, d, a, e, c);
            var f = $c79bde28d689cb05$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c79bde28d689cb05$var$Zf(d) ? (f = !0, $c79bde28d689cb05$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c79bde28d689cb05$var$ah(b), e.updater = $c79bde28d689cb05$var$nh, b.stateNode = e, e._reactInternals = b, $c79bde28d689cb05$var$rh(b, d, a, c), b = $c79bde28d689cb05$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $c79bde28d689cb05$var$I && f && $c79bde28d689cb05$var$vg(b), $c79bde28d689cb05$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c79bde28d689cb05$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c79bde28d689cb05$var$$k(d);
                a = $c79bde28d689cb05$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $c79bde28d689cb05$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c79bde28d689cb05$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c79bde28d689cb05$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c79bde28d689cb05$var$aj(null, b, d, $c79bde28d689cb05$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($c79bde28d689cb05$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $c79bde28d689cb05$var$lj(b);
                if (null === a) throw Error($c79bde28d689cb05$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c79bde28d689cb05$var$bh(a, b);
                $c79bde28d689cb05$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(423)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c79bde28d689cb05$var$Ki(Error($c79bde28d689cb05$var$p(424)), b);
                        b = $c79bde28d689cb05$var$mj(a, b, d, c, e);
                        break a;
                    } else for($c79bde28d689cb05$var$yg = $c79bde28d689cb05$var$Lf(b.stateNode.containerInfo.firstChild), $c79bde28d689cb05$var$xg = b, $c79bde28d689cb05$var$I = !0, $c79bde28d689cb05$var$zg = null, c = $c79bde28d689cb05$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c79bde28d689cb05$var$Ig();
                    if (d === e) {
                        b = $c79bde28d689cb05$var$$i(a, b, c);
                        break a;
                    }
                    $c79bde28d689cb05$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c79bde28d689cb05$var$Kh(b), null === a && $c79bde28d689cb05$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c79bde28d689cb05$var$Ef(d, e) ? g = null : null !== f && $c79bde28d689cb05$var$Ef(d, f) && (b.flags |= 32), $c79bde28d689cb05$var$hj(a, b), $c79bde28d689cb05$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $c79bde28d689cb05$var$Eg(b), null;
        case 13:
            return $c79bde28d689cb05$var$pj(a, b, c);
        case 4:
            return $c79bde28d689cb05$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c79bde28d689cb05$var$Bh(b, null, d, c) : $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$Zi(a, b, d, e, c);
        case 7:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $c79bde28d689cb05$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c79bde28d689cb05$var$G($c79bde28d689cb05$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c79bde28d689cb05$var$He(f.value, g)) {
                        if (f.children === e.children && !$c79bde28d689cb05$var$Wf.current) {
                            b = $c79bde28d689cb05$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $c79bde28d689cb05$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $c79bde28d689cb05$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($c79bde28d689cb05$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $c79bde28d689cb05$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $c79bde28d689cb05$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c79bde28d689cb05$var$Tg(b, c), e = $c79bde28d689cb05$var$Vg(e), d = d(e), b.flags |= 1, $c79bde28d689cb05$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c79bde28d689cb05$var$Lg(d, b.pendingProps), e = $c79bde28d689cb05$var$Lg(d.type, e), $c79bde28d689cb05$var$aj(a, b, d, e, c);
        case 15:
            return $c79bde28d689cb05$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c79bde28d689cb05$var$Lg(d, e), $c79bde28d689cb05$var$jj(a, b), b.tag = 1, $c79bde28d689cb05$var$Zf(d) ? (a = !0, $c79bde28d689cb05$var$cg(b)) : a = !1, $c79bde28d689cb05$var$Tg(b, c), $c79bde28d689cb05$var$ph(b, d, e), $c79bde28d689cb05$var$rh(b, d, e, c), $c79bde28d689cb05$var$kj(null, b, d, !0, a, c);
        case 19:
            return $c79bde28d689cb05$var$yj(a, b, c);
        case 22:
            return $c79bde28d689cb05$var$ej(a, b, c);
    }
    throw Error($c79bde28d689cb05$var$p(156, b.tag));
};
function $c79bde28d689cb05$var$Gk(a, b) {
    return $c79bde28d689cb05$var$ac(a, b);
}
function $c79bde28d689cb05$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c79bde28d689cb05$var$Bg(a, b, c, d) {
    return new $c79bde28d689cb05$var$al(a, b, c, d);
}
function $c79bde28d689cb05$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c79bde28d689cb05$var$$k(a) {
    if ("function" === typeof a) return $c79bde28d689cb05$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c79bde28d689cb05$var$Da) return 11;
        if (a === $c79bde28d689cb05$var$Ga) return 14;
    }
    return 2;
}
function $c79bde28d689cb05$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $c79bde28d689cb05$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $c79bde28d689cb05$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c79bde28d689cb05$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c79bde28d689cb05$var$ya:
            return $c79bde28d689cb05$var$Ah(c.children, e, f, b);
        case $c79bde28d689cb05$var$za:
            g = 8;
            e |= 8;
            break;
        case $c79bde28d689cb05$var$Aa:
            return a = $c79bde28d689cb05$var$Bg(12, c, b, e | 2), a.elementType = $c79bde28d689cb05$var$Aa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ea:
            return a = $c79bde28d689cb05$var$Bg(13, c, b, e), a.elementType = $c79bde28d689cb05$var$Ea, a.lanes = f, a;
        case $c79bde28d689cb05$var$Fa:
            return a = $c79bde28d689cb05$var$Bg(19, c, b, e), a.elementType = $c79bde28d689cb05$var$Fa, a.lanes = f, a;
        case $c79bde28d689cb05$var$Ia:
            return $c79bde28d689cb05$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c79bde28d689cb05$var$Ba:
                    g = 10;
                    break a;
                case $c79bde28d689cb05$var$Ca:
                    g = 9;
                    break a;
                case $c79bde28d689cb05$var$Da:
                    g = 11;
                    break a;
                case $c79bde28d689cb05$var$Ga:
                    g = 14;
                    break a;
                case $c79bde28d689cb05$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c79bde28d689cb05$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c79bde28d689cb05$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c79bde28d689cb05$var$Ah(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$qj(a, b, c, d) {
    a = $c79bde28d689cb05$var$Bg(22, a, d, b);
    a.elementType = $c79bde28d689cb05$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c79bde28d689cb05$var$xh(a, b, c) {
    a = $c79bde28d689cb05$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c79bde28d689cb05$var$zh(a, b, c) {
    b = $c79bde28d689cb05$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c79bde28d689cb05$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c79bde28d689cb05$var$zc(0);
    this.expirationTimes = $c79bde28d689cb05$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c79bde28d689cb05$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $c79bde28d689cb05$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $c79bde28d689cb05$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $c79bde28d689cb05$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c79bde28d689cb05$var$ah(f);
    return a;
}
function $c79bde28d689cb05$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c79bde28d689cb05$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c79bde28d689cb05$var$el(a) {
    if (!a) return $c79bde28d689cb05$var$Vf;
    a = a._reactInternals;
    a: {
        if ($c79bde28d689cb05$var$Vb(a) !== a || 1 !== a.tag) throw Error($c79bde28d689cb05$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c79bde28d689cb05$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c79bde28d689cb05$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c79bde28d689cb05$var$Zf(c)) return $c79bde28d689cb05$var$bg(a, c, b);
    }
    return b;
}
function $c79bde28d689cb05$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $c79bde28d689cb05$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $c79bde28d689cb05$var$el(null);
    c = a.current;
    d = $c79bde28d689cb05$var$L();
    e = $c79bde28d689cb05$var$lh(c);
    f = $c79bde28d689cb05$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c79bde28d689cb05$var$dh(c, f, e);
    a.current.lanes = e;
    $c79bde28d689cb05$var$Ac(a, e, d);
    $c79bde28d689cb05$var$Ek(a, d);
    return a;
}
function $c79bde28d689cb05$var$gl(a, b, c, d) {
    var e = b.current, f = $c79bde28d689cb05$var$L(), g = $c79bde28d689cb05$var$lh(e);
    c = $c79bde28d689cb05$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c79bde28d689cb05$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c79bde28d689cb05$var$dh(e, b, g);
    null !== a && ($c79bde28d689cb05$var$mh(a, e, g, f), $c79bde28d689cb05$var$eh(a, e, g));
    return g;
}
function $c79bde28d689cb05$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c79bde28d689cb05$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c79bde28d689cb05$var$jl(a, b) {
    $c79bde28d689cb05$var$il(a, b);
    (a = a.alternate) && $c79bde28d689cb05$var$il(a, b);
}
function $c79bde28d689cb05$var$kl() {
    return null;
}
var $c79bde28d689cb05$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c79bde28d689cb05$var$ml(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.render = $c79bde28d689cb05$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c79bde28d689cb05$var$p(409));
    $c79bde28d689cb05$var$gl(a, b, null, null);
};
$c79bde28d689cb05$var$nl.prototype.unmount = $c79bde28d689cb05$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c79bde28d689cb05$var$Sk(function() {
            $c79bde28d689cb05$var$gl(null, a, null, null);
        });
        b[$c79bde28d689cb05$var$uf] = null;
    }
};
function $c79bde28d689cb05$var$nl(a) {
    this._internalRoot = a;
}
$c79bde28d689cb05$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c79bde28d689cb05$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c79bde28d689cb05$var$Qc.length && 0 !== b && b < $c79bde28d689cb05$var$Qc[c].priority; c++);
        $c79bde28d689cb05$var$Qc.splice(c, 0, a);
        0 === c && $c79bde28d689cb05$var$Vc(a);
    }
};
function $c79bde28d689cb05$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c79bde28d689cb05$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c79bde28d689cb05$var$ql() {}
function $c79bde28d689cb05$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                f.call(a);
            };
        }
        var g = $c79bde28d689cb05$var$fl(b, d, a, 0, null, !1, !1, "", $c79bde28d689cb05$var$ql);
        a._reactRootContainer = g;
        a[$c79bde28d689cb05$var$uf] = g.current;
        $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
        $c79bde28d689cb05$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c79bde28d689cb05$var$hl(k);
            h.call(a);
        };
    }
    var k = $c79bde28d689cb05$var$cl(a, 0, !1, null, null, !1, !1, "", $c79bde28d689cb05$var$ql);
    a._reactRootContainer = k;
    a[$c79bde28d689cb05$var$uf] = k.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    $c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$gl(b, k, c, d);
    });
    return k;
}
function $c79bde28d689cb05$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c79bde28d689cb05$var$hl(g);
                h.call(a);
            };
        }
        $c79bde28d689cb05$var$gl(b, g, a, e);
    } else g = $c79bde28d689cb05$var$rl(c, b, a, e, d);
    return $c79bde28d689cb05$var$hl(g);
}
$c79bde28d689cb05$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c79bde28d689cb05$var$tc(b.pendingLanes);
                0 !== c && ($c79bde28d689cb05$var$Cc(b, c | 1), $c79bde28d689cb05$var$Ek(b, $c79bde28d689cb05$var$B()), 0 === ($c79bde28d689cb05$var$K & 6) && ($c79bde28d689cb05$var$Hj = $c79bde28d689cb05$var$B() + 500, $c79bde28d689cb05$var$jg()));
            }
            break;
        case 13:
            $c79bde28d689cb05$var$Sk(function() {
                var b = $c79bde28d689cb05$var$Zg(a, 1);
                if (null !== b) {
                    var c = $c79bde28d689cb05$var$L();
                    $c79bde28d689cb05$var$mh(b, a, 1, c);
                }
            }), $c79bde28d689cb05$var$jl(a, 1);
    }
};
$c79bde28d689cb05$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(b, a, 134217728, c);
        }
        $c79bde28d689cb05$var$jl(a, 134217728);
    }
};
$c79bde28d689cb05$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $c79bde28d689cb05$var$lh(a), c = $c79bde28d689cb05$var$Zg(a, b);
        if (null !== c) {
            var d = $c79bde28d689cb05$var$L();
            $c79bde28d689cb05$var$mh(c, a, b, d);
        }
        $c79bde28d689cb05$var$jl(a, b);
    }
};
$c79bde28d689cb05$var$Hc = function() {
    return $c79bde28d689cb05$var$C;
};
$c79bde28d689cb05$var$Ic = function(a, b) {
    var c = $c79bde28d689cb05$var$C;
    try {
        return $c79bde28d689cb05$var$C = a, b();
    } finally{
        $c79bde28d689cb05$var$C = c;
    }
};
$c79bde28d689cb05$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c79bde28d689cb05$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c79bde28d689cb05$var$Db(d);
                        if (!e) throw Error($c79bde28d689cb05$var$p(90));
                        $c79bde28d689cb05$var$Wa(d);
                        $c79bde28d689cb05$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c79bde28d689cb05$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $c79bde28d689cb05$var$fb(a, !!c.multiple, b, !1);
    }
};
$c79bde28d689cb05$var$Gb = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$var$Hb = $c79bde28d689cb05$var$Sk;
var $c79bde28d689cb05$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $c79bde28d689cb05$var$Cb,
        $c79bde28d689cb05$var$ue,
        $c79bde28d689cb05$var$Db,
        $c79bde28d689cb05$var$Eb,
        $c79bde28d689cb05$var$Fb,
        $c79bde28d689cb05$var$Rk
    ]
}, $c79bde28d689cb05$var$ul = {
    findFiberByHostInstance: $c79bde28d689cb05$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $c79bde28d689cb05$var$vl = {
    bundleType: $c79bde28d689cb05$var$ul.bundleType,
    version: $c79bde28d689cb05$var$ul.version,
    rendererPackageName: $c79bde28d689cb05$var$ul.rendererPackageName,
    rendererConfig: $c79bde28d689cb05$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c79bde28d689cb05$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c79bde28d689cb05$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c79bde28d689cb05$var$ul.findFiberByHostInstance || $c79bde28d689cb05$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c79bde28d689cb05$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c79bde28d689cb05$var$wl.isDisabled && $c79bde28d689cb05$var$wl.supportsFiber) try {
        $c79bde28d689cb05$var$kc = $c79bde28d689cb05$var$wl.inject($c79bde28d689cb05$var$vl), $c79bde28d689cb05$var$lc = $c79bde28d689cb05$var$wl;
    } catch (a) {}
}
$c79bde28d689cb05$export$ae55be85d98224ed = $c79bde28d689cb05$var$tl;
$c79bde28d689cb05$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c79bde28d689cb05$var$ol(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$dl(a, b, null, c);
};
$c79bde28d689cb05$export$882461b6382ed46c = function(a, b) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(299));
    var c = !1, d = "", e = $c79bde28d689cb05$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c79bde28d689cb05$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $c79bde28d689cb05$var$ml(b);
};
$c79bde28d689cb05$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c79bde28d689cb05$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c79bde28d689cb05$var$p(268, a));
    }
    a = $c79bde28d689cb05$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c79bde28d689cb05$export$cd75ccfd720a3cd4 = function(a) {
    return $c79bde28d689cb05$var$Sk(a);
};
$c79bde28d689cb05$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !0, c);
};
$c79bde28d689cb05$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c79bde28d689cb05$var$ol(a)) throw Error($c79bde28d689cb05$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c79bde28d689cb05$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c79bde28d689cb05$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c79bde28d689cb05$var$uf] = b.current;
    $c79bde28d689cb05$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c79bde28d689cb05$var$nl(b);
};
$c79bde28d689cb05$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c79bde28d689cb05$var$pl(b)) throw Error($c79bde28d689cb05$var$p(200));
    return $c79bde28d689cb05$var$sl(null, a, b, !1, c);
};
$c79bde28d689cb05$export$502457920280e6be = function(a) {
    if (!$c79bde28d689cb05$var$pl(a)) throw Error($c79bde28d689cb05$var$p(40));
    return a._reactRootContainer ? ($c79bde28d689cb05$var$Sk(function() {
        $c79bde28d689cb05$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c79bde28d689cb05$var$uf] = null;
        });
    }), !0) : !1;
};
$c79bde28d689cb05$export$c78a37762a8d58e1 = $c79bde28d689cb05$var$Rk;
$c79bde28d689cb05$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c79bde28d689cb05$var$pl(c)) throw Error($c79bde28d689cb05$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c79bde28d689cb05$var$p(38));
    return $c79bde28d689cb05$var$sl(a, b, c, !1, d);
};
$c79bde28d689cb05$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("ibqfJ", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dnqd8"));

});
parcelRegister("dnqd8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $9bd1c1496009b220$export$c4744153514ff05d; }, function (v) { return $9bd1c1496009b220$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7; }, function (v) { return $9bd1c1496009b220$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $9bd1c1496009b220$export$e26fe2ed2fa76875; }, function (v) { return $9bd1c1496009b220$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $9bd1c1496009b220$export$502329bbf4b505b1; }, function (v) { return $9bd1c1496009b220$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $9bd1c1496009b220$export$6e3807111c4874c4; }, function (v) { return $9bd1c1496009b220$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $9bd1c1496009b220$export$c27134553091fb3a; }, function (v) { return $9bd1c1496009b220$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $9bd1c1496009b220$export$33ee1acdc04fd2a2; }, function (v) { return $9bd1c1496009b220$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $9bd1c1496009b220$export$b00a404bbd5edef2; }, function (v) { return $9bd1c1496009b220$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $9bd1c1496009b220$export$8352ce38b91d0c62; }, function (v) { return $9bd1c1496009b220$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $9bd1c1496009b220$export$d66a1c1c77bd778b; }, function (v) { return $9bd1c1496009b220$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $9bd1c1496009b220$export$d3dfb8e4810cb555; }, function (v) { return $9bd1c1496009b220$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $9bd1c1496009b220$export$839f9183b0465a69; }, function (v) { return $9bd1c1496009b220$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $9bd1c1496009b220$export$72fdf0e06517287b; }, function (v) { return $9bd1c1496009b220$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $9bd1c1496009b220$export$4b844e58a3e414b4; }, function (v) { return $9bd1c1496009b220$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $9bd1c1496009b220$export$816d2913ae6b83b1; }, function (v) { return $9bd1c1496009b220$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $9bd1c1496009b220$export$61bcfe829111a1d0; }, function (v) { return $9bd1c1496009b220$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $9bd1c1496009b220$export$7ee8c9beb337bc3f; }, function (v) { return $9bd1c1496009b220$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $9bd1c1496009b220$export$b5836b71941fa3ed; }, function (v) { return $9bd1c1496009b220$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $9bd1c1496009b220$export$cf845f2c119da08a; }, function (v) { return $9bd1c1496009b220$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9bd1c1496009b220$export$c4744153514ff05d;
var $9bd1c1496009b220$export$3e506c1ccc9cc1a7;
var $9bd1c1496009b220$export$e26fe2ed2fa76875;
var $9bd1c1496009b220$export$502329bbf4b505b1;
var $9bd1c1496009b220$export$6e3807111c4874c4;
var $9bd1c1496009b220$export$c27134553091fb3a;
var $9bd1c1496009b220$export$33ee1acdc04fd2a2;
var $9bd1c1496009b220$export$b00a404bbd5edef2;
var $9bd1c1496009b220$export$8352ce38b91d0c62;
var $9bd1c1496009b220$export$d66a1c1c77bd778b;
var $9bd1c1496009b220$export$d3dfb8e4810cb555;
var $9bd1c1496009b220$export$839f9183b0465a69;
var $9bd1c1496009b220$export$72fdf0e06517287b;
var $9bd1c1496009b220$export$4b844e58a3e414b4;
var $9bd1c1496009b220$export$816d2913ae6b83b1;
var $9bd1c1496009b220$export$61bcfe829111a1d0;
var $9bd1c1496009b220$export$7ee8c9beb337bc3f;
var $9bd1c1496009b220$export$b5836b71941fa3ed;
var $9bd1c1496009b220$export$cf845f2c119da08a;
"use strict";
function $9bd1c1496009b220$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $9bd1c1496009b220$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $9bd1c1496009b220$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $9bd1c1496009b220$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $9bd1c1496009b220$var$g(C, c)) n < e && 0 > $9bd1c1496009b220$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $9bd1c1496009b220$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $9bd1c1496009b220$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $9bd1c1496009b220$var$l = performance;
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$l.now();
    };
} else {
    var $9bd1c1496009b220$var$p = Date, $9bd1c1496009b220$var$q = $9bd1c1496009b220$var$p.now();
    $9bd1c1496009b220$export$c4744153514ff05d = function() {
        return $9bd1c1496009b220$var$p.now() - $9bd1c1496009b220$var$q;
    };
}
var $9bd1c1496009b220$var$r = [], $9bd1c1496009b220$var$t = [], $9bd1c1496009b220$var$u = 1, $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = 3, $9bd1c1496009b220$var$z = !1, $9bd1c1496009b220$var$A = !1, $9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$D = "function" === typeof setTimeout ? setTimeout : null, $9bd1c1496009b220$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $9bd1c1496009b220$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $9bd1c1496009b220$var$G(a) {
    for(var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t); null !== b;){
        if (null === b.callback) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t);
        else if (b.startTime <= a) $9bd1c1496009b220$var$k($9bd1c1496009b220$var$t), b.sortIndex = b.expirationTime, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, b);
        else break;
        b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
    }
}
function $9bd1c1496009b220$var$H(a) {
    $9bd1c1496009b220$var$B = !1;
    $9bd1c1496009b220$var$G(a);
    if (!$9bd1c1496009b220$var$A) {
        if (null !== $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r)) $9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J);
        else {
            var b = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== b && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, b.startTime - a);
        }
    }
}
function $9bd1c1496009b220$var$J(a, b) {
    $9bd1c1496009b220$var$A = !1;
    $9bd1c1496009b220$var$B && ($9bd1c1496009b220$var$B = !1, $9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1);
    $9bd1c1496009b220$var$z = !0;
    var c = $9bd1c1496009b220$var$y;
    try {
        $9bd1c1496009b220$var$G(b);
        for($9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r); null !== $9bd1c1496009b220$var$v && (!($9bd1c1496009b220$var$v.expirationTime > b) || a && !$9bd1c1496009b220$var$M());){
            var d = $9bd1c1496009b220$var$v.callback;
            if ("function" === typeof d) {
                $9bd1c1496009b220$var$v.callback = null;
                $9bd1c1496009b220$var$y = $9bd1c1496009b220$var$v.priorityLevel;
                var e = d($9bd1c1496009b220$var$v.expirationTime <= b);
                b = $9bd1c1496009b220$export$c4744153514ff05d();
                "function" === typeof e ? $9bd1c1496009b220$var$v.callback = e : $9bd1c1496009b220$var$v === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
                $9bd1c1496009b220$var$G(b);
            } else $9bd1c1496009b220$var$k($9bd1c1496009b220$var$r);
            $9bd1c1496009b220$var$v = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
        }
        if (null !== $9bd1c1496009b220$var$v) var w = !0;
        else {
            var m = $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t);
            null !== m && $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $9bd1c1496009b220$var$v = null, $9bd1c1496009b220$var$y = c, $9bd1c1496009b220$var$z = !1;
    }
}
var $9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null, $9bd1c1496009b220$var$L = -1, $9bd1c1496009b220$var$P = 5, $9bd1c1496009b220$var$Q = -1;
function $9bd1c1496009b220$var$M() {
    return $9bd1c1496009b220$export$c4744153514ff05d() - $9bd1c1496009b220$var$Q < $9bd1c1496009b220$var$P ? !1 : !0;
}
function $9bd1c1496009b220$var$R() {
    if (null !== $9bd1c1496009b220$var$O) {
        var a = $9bd1c1496009b220$export$c4744153514ff05d();
        $9bd1c1496009b220$var$Q = a;
        var b = !0;
        try {
            b = $9bd1c1496009b220$var$O(!0, a);
        } finally{
            b ? $9bd1c1496009b220$var$S() : ($9bd1c1496009b220$var$N = !1, $9bd1c1496009b220$var$O = null);
        }
    } else $9bd1c1496009b220$var$N = !1;
}
var $9bd1c1496009b220$var$S;
if ("function" === typeof $9bd1c1496009b220$var$F) $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$F($9bd1c1496009b220$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $9bd1c1496009b220$var$T = new MessageChannel, $9bd1c1496009b220$var$U = $9bd1c1496009b220$var$T.port2;
    $9bd1c1496009b220$var$T.port1.onmessage = $9bd1c1496009b220$var$R;
    $9bd1c1496009b220$var$S = function() {
        $9bd1c1496009b220$var$U.postMessage(null);
    };
} else $9bd1c1496009b220$var$S = function() {
    $9bd1c1496009b220$var$D($9bd1c1496009b220$var$R, 0);
};
function $9bd1c1496009b220$var$I(a) {
    $9bd1c1496009b220$var$O = a;
    $9bd1c1496009b220$var$N || ($9bd1c1496009b220$var$N = !0, $9bd1c1496009b220$var$S());
}
function $9bd1c1496009b220$var$K(a, b) {
    $9bd1c1496009b220$var$L = $9bd1c1496009b220$var$D(function() {
        a($9bd1c1496009b220$export$c4744153514ff05d());
    }, b);
}
$9bd1c1496009b220$export$3e506c1ccc9cc1a7 = 5;
$9bd1c1496009b220$export$e26fe2ed2fa76875 = 1;
$9bd1c1496009b220$export$502329bbf4b505b1 = 4;
$9bd1c1496009b220$export$6e3807111c4874c4 = 3;
$9bd1c1496009b220$export$c27134553091fb3a = null;
$9bd1c1496009b220$export$33ee1acdc04fd2a2 = 2;
$9bd1c1496009b220$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$9bd1c1496009b220$export$8352ce38b91d0c62 = function() {
    $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J));
};
$9bd1c1496009b220$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $9bd1c1496009b220$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$9bd1c1496009b220$export$d3dfb8e4810cb555 = function() {
    return $9bd1c1496009b220$var$y;
};
$9bd1c1496009b220$export$839f9183b0465a69 = function() {
    return $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r);
};
$9bd1c1496009b220$export$72fdf0e06517287b = function(a) {
    switch($9bd1c1496009b220$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $9bd1c1496009b220$var$y;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = b;
    try {
        return a();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$4b844e58a3e414b4 = function() {};
$9bd1c1496009b220$export$816d2913ae6b83b1 = function() {};
$9bd1c1496009b220$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $9bd1c1496009b220$var$y;
    $9bd1c1496009b220$var$y = a;
    try {
        return b();
    } finally{
        $9bd1c1496009b220$var$y = c;
    }
};
$9bd1c1496009b220$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $9bd1c1496009b220$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $9bd1c1496009b220$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$t, a), null === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$r) && a === $9bd1c1496009b220$var$h($9bd1c1496009b220$var$t) && ($9bd1c1496009b220$var$B ? ($9bd1c1496009b220$var$E($9bd1c1496009b220$var$L), $9bd1c1496009b220$var$L = -1) : $9bd1c1496009b220$var$B = !0, $9bd1c1496009b220$var$K($9bd1c1496009b220$var$H, c - d))) : (a.sortIndex = e, $9bd1c1496009b220$var$f($9bd1c1496009b220$var$r, a), $9bd1c1496009b220$var$A || $9bd1c1496009b220$var$z || ($9bd1c1496009b220$var$A = !0, $9bd1c1496009b220$var$I($9bd1c1496009b220$var$J)));
    return a;
};
$9bd1c1496009b220$export$b5836b71941fa3ed = $9bd1c1496009b220$var$M;
$9bd1c1496009b220$export$cf845f2c119da08a = function(a) {
    var b = $9bd1c1496009b220$var$y;
    return function() {
        var c = $9bd1c1496009b220$var$y;
        $9bd1c1496009b220$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $9bd1c1496009b220$var$y = c;
        }
    };
};

});



parcelRegister("32XxQ", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return observable; });
$parcel$export(module.exports, "getDependencyTree", function () { return getDependencyTree; });
$parcel$export(module.exports, "Reaction", function () { return Reaction; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "makeObservable", function () { return makeObservable; });
$parcel$export(module.exports, "makeAutoObservable", function () { return makeAutoObservable; });
$parcel$export(module.exports, "runInAction", function () { return runInAction; });
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    } /**
   * Invoke this method to notify mobx that your atom has been used somehow.
   * Returns true if there is currently a reactive context.
   */ ;
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    } /**
   * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
   */ ;
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = isAction(descriptor.set) ? descriptor.set // See #4553
         : createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        var _this$value_;
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "	".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    } /**
   * internal, use schedule() if you intend to kick off a reaction
   */ ;
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        if ("dispose" in Symbol && typeof Symbol.dispose === "symbol") dispose[Symbol.dispose] = dispose;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    } /** Merge another object into this object, returns this. */ ;
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    } /**
   * @param {PropertyKey} key
   * @param {any} value
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    } /**
   * @param {PropertyKey} key
   * @param {Annotation|boolean} annotation true - use default annotation, false - ignore prop
   */ ;
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {Annotation|boolean} annotation true - use default annotation, false - copy as is
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    } /**
   * @param {PropertyKey} key
   * @param {PropertyDescriptor} descriptor
   * @param {boolean} proxyTrap whether it's called from proxy trap
   * @returns {boolean|null} true on success, false on failure (proxyTrap + non-configurable), null when cancelled by interceptor
   */ ;
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    } /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ ;
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("1nNjm", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $101e30a3eef9e9c6$export$306c0aa65ff9ec16; }, function (v) { return $101e30a3eef9e9c6$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $101e30a3eef9e9c6$export$306c0aa65ff9ec16;
"use strict";

var $exYeM = parcelRequire("exYeM");
function $101e30a3eef9e9c6$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $101e30a3eef9e9c6$var$objectIs = "function" === typeof Object.is ? Object.is : $101e30a3eef9e9c6$var$is, $101e30a3eef9e9c6$var$useState = $exYeM.useState, $101e30a3eef9e9c6$var$useEffect = $exYeM.useEffect, $101e30a3eef9e9c6$var$useLayoutEffect = $exYeM.useLayoutEffect, $101e30a3eef9e9c6$var$useDebugValue = $exYeM.useDebugValue;
function $101e30a3eef9e9c6$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $101e30a3eef9e9c6$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $101e30a3eef9e9c6$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $101e30a3eef9e9c6$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $101e30a3eef9e9c6$var$useEffect(function() {
        $101e30a3eef9e9c6$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $101e30a3eef9e9c6$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $101e30a3eef9e9c6$var$useDebugValue(value);
    return value;
}
function $101e30a3eef9e9c6$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$101e30a3eef9e9c6$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $101e30a3eef9e9c6$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $101e30a3eef9e9c6$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $101e30a3eef9e9c6$var$useSyncExternalStore$1 : $101e30a3eef9e9c6$var$useSyncExternalStore$2;
$101e30a3eef9e9c6$export$306c0aa65ff9ec16 = void 0 !== $exYeM.useSyncExternalStore ? $exYeM.useSyncExternalStore : $101e30a3eef9e9c6$var$shim;

});

var $7ead0b1397a835ed$exports = {};
"use strict";

$7ead0b1397a835ed$exports = (parcelRequire("6ObR8"));


var $7bd215913159ea08$export$882461b6382ed46c;
var $7bd215913159ea08$export$757ceba2d55c277e;
"use strict";
var $97dc602bd7e23afa$exports = {};
"use strict";
function $97dc602bd7e23afa$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($97dc602bd7e23afa$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$97dc602bd7e23afa$var$checkDCE();

$97dc602bd7e23afa$exports = (parcelRequire("h8vP0"));


var $7bd215913159ea08$var$i;
$7bd215913159ea08$export$882461b6382ed46c = $97dc602bd7e23afa$exports.createRoot;
$7bd215913159ea08$export$757ceba2d55c277e = $97dc602bd7e23afa$exports.hydrateRoot;


parcelRequire("exYeM");
const $86c1020597e9be8a$export$b6ba90e55ec79c0b = 64;




var $exYeM = parcelRequire("exYeM");

var $32XxQ = parcelRequire("32XxQ");
class $d198ee6d45780193$export$6da0b3c496770736 {
    constructor(row, col){
        this.row = row;
        this.col = col;
    }
    toHash() {
        return this.row + "." + this.col;
    }
    toGridIndex(dimensions) {
        return this.row * dimensions.width + this.col;
    }
    isInDimensions(dimensions) {
        return this.row >= 0 && this.row < dimensions.height && this.col >= 0 && this.col < dimensions.width;
    }
    addDirection(direction) {
        switch(direction){
            case "up":
                return new $d198ee6d45780193$export$6da0b3c496770736(this.row - 1, this.col);
            case "down":
                return new $d198ee6d45780193$export$6da0b3c496770736(this.row + 1, this.col);
            case "left":
                return new $d198ee6d45780193$export$6da0b3c496770736(this.row, this.col - 1);
            case "right":
                return new $d198ee6d45780193$export$6da0b3c496770736(this.row, this.col + 1);
        }
    }
    static fromGridIndex(index, dimensions) {
        return new $d198ee6d45780193$export$6da0b3c496770736(Math.floor(index / dimensions.height), Math.floor(index % dimensions.width));
    }
    static fromHash(hash) {
        const [row, col] = hash.split(".");
        return new $d198ee6d45780193$export$6da0b3c496770736(parseInt(row), parseInt(col));
    }
}


function $3f1d9af7161661b8$export$6dddf77696535a87(index, direction, gridDimensions) {
    switch(direction){
        case "up":
            return Math.max(0, index - gridDimensions.width);
        case "down":
            return Math.min(index + gridDimensions.width, gridDimensions.width * gridDimensions.height);
        case "left":
            return Math.max(0, index - 1);
        case "right":
            return Math.min(index + 1, gridDimensions.width * gridDimensions.height);
    }
}


class $f92eb0fa0eb8171d$export$f361d4ae234b90f4 {
    toString() {
        return this.type;
    }
    isType(type) {
        return this.type === type;
    }
}


class $67053d49856f45d3$export$5a0d3ff4a91d4c77 extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        if (context.mana % 2 === 0) context.cursorDirection = "down";
        else context.cursorDirection = "right";
    }
    constructor(...args){
        super(...args);
        this.type = "branch-even";
    }
}



class $50d5888edad9fe75$export$f40f5dc2d624eaeb extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        context.cursorDirection = "down";
    }
    constructor(...args){
        super(...args);
        this.type = "face-down";
    }
}



class $f5f9de6604d968c6$export$72eb618ab4441b88 extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        context.cursorDirection = "left";
    }
    constructor(...args){
        super(...args);
        this.type = "face-left";
    }
}



class $a3d4f96d1719b9ae$export$31fce7016ebbf405 extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        context.cursorDirection = "right";
    }
    constructor(...args){
        super(...args);
        this.type = "face-right";
    }
}



const $8e30beaa25056dbb$var$DIRECTIONS_IN_CLOCKWISE_ORDER = [
    "up",
    "right",
    "down",
    "left"
];
function $8e30beaa25056dbb$var$getNextCloseWiseDirection(direction) {
    const currentIndex = $8e30beaa25056dbb$var$DIRECTIONS_IN_CLOCKWISE_ORDER.indexOf(direction);
    // mod by length to wrap around if we're on the last index
    const nextIndex = (currentIndex + 1) % $8e30beaa25056dbb$var$DIRECTIONS_IN_CLOCKWISE_ORDER.length;
    return $8e30beaa25056dbb$var$DIRECTIONS_IN_CLOCKWISE_ORDER[nextIndex];
}
class $8e30beaa25056dbb$export$d7e2755af7717cc1 extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    constructor(direction){
        super();
        this.direction = direction;
        this.type = "face-" + this.direction + "-rotate";
    }
    act(context) {
        context.cursorDirection = this.direction;
        context.instructions.set(context.cursorGridLocation.toHash(), new $8e30beaa25056dbb$export$d7e2755af7717cc1($8e30beaa25056dbb$var$getNextCloseWiseDirection(this.direction)));
    }
}



class $f0c2ed4ec4941333$export$2c07ade20ba8a592 extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        context.cursorDirection = "up";
    }
    constructor(...args){
        super(...args);
        this.type = "face-up";
    }
}



class $71ce162500441f85$export$971a77484a9337eb extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        context.cursorIndex += context.flux;
    }
    constructor(...args){
        super(...args);
        this.type = "flux-jump";
    }
}



class $bc240b5936eb67e9$export$89ec00397c66925e extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        context.cursorIndex += context.mana;
        context.mana = 0;
    }
    constructor(...args){
        super(...args);
        this.type = "jump";
    }
}



class $ce4a6692ed0e4519$export$a53bd5ca7b94c3cf extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        const neighbors = context.getNeighboringInstructions(context.cursorGridLocation);
        const manaCount = neighbors.reduce((count, neighbor)=>{
            if (neighbor.type === "mana") return count + 1;
            return count;
        }, 0);
        context.mana += manaCount;
    }
    constructor(...args){
        super(...args);
        this.type = "mana-focus";
    }
}



class $ebc781f9fbd5705c$export$96c78b3861c0d9ea extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        context.mana += 1;
        context.flux += 1;
    }
    constructor(...args){
        super(...args);
        this.type = "mana";
    }
}




class $d303633a5f0bd066$export$2d2e72c185c80375 extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        const location = (0, $d198ee6d45780193$export$6da0b3c496770736).fromGridIndex(context.cursorIndex, context.gridDimensions);
        location.row += 1;
        location.col = 0;
        context.cursorIndex = location.toGridIndex(context.gridDimensions);
        context.flux += 1;
        return {
            shouldAdvanceCursor: false
        };
    }
    constructor(...args){
        super(...args);
        this.type = "new-line";
    }
}



class $ea47a8ff3afed1df$export$5a6e314e58718166 extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    constructor(ref){
        super();
        this.ref = ref;
        this.type = "reference-" + this.ref;
    }
    act(context) {
        context.reference.push(this.ref);
    }
}


function $b3b887f847284fef$export$497a80669b9843df(array) {
    return array[Math.floor(Math.random() * array.length)];
}



class $55702a78e75e93a6$export$e0e44f23128389a extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        context.flux += (0, $b3b887f847284fef$export$497a80669b9843df)([
            1,
            2,
            3
        ]);
    }
    constructor(...args){
        super(...args);
        this.type = "sensor-input";
    }
}




class $0a100446e151ef61$export$8880ce646cdc2018 extends (0, $f92eb0fa0eb8171d$export$f361d4ae234b90f4) {
    act(context) {
        context.cursorIndex = new (0, $d198ee6d45780193$export$6da0b3c496770736)(context.cursorGridLocation.col, context.cursorGridLocation.row).toGridIndex(context.gridDimensions);
        return {
            shouldAdvanceCursor: false
        };
    }
    constructor(...args){
        super(...args);
        this.type = "transpose";
    }
}


const $ed3bff3811882801$export$21ba78b50397401d = [
    new (0, $f0c2ed4ec4941333$export$2c07ade20ba8a592)(),
    new (0, $50d5888edad9fe75$export$f40f5dc2d624eaeb)(),
    new (0, $f5f9de6604d968c6$export$72eb618ab4441b88)(),
    new (0, $a3d4f96d1719b9ae$export$31fce7016ebbf405)(),
    new (0, $ce4a6692ed0e4519$export$a53bd5ca7b94c3cf)(),
    new (0, $ebc781f9fbd5705c$export$96c78b3861c0d9ea)(),
    new (0, $d303633a5f0bd066$export$2d2e72c185c80375)(),
    new (0, $bc240b5936eb67e9$export$89ec00397c66925e)(),
    new (0, $0a100446e151ef61$export$8880ce646cdc2018)(),
    new (0, $67053d49856f45d3$export$5a0d3ff4a91d4c77)(),
    new (0, $ea47a8ff3afed1df$export$5a6e314e58718166)("test"),
    new (0, $ea47a8ff3afed1df$export$5a6e314e58718166)("test-other"),
    new (0, $8e30beaa25056dbb$export$d7e2755af7717cc1)("down"),
    new (0, $71ce162500441f85$export$971a77484a9337eb)(),
    new (0, $55702a78e75e93a6$export$e0e44f23128389a)()
];
const $ed3bff3811882801$export$f6f75c26df0cd6a0 = Object.fromEntries($ed3bff3811882801$export$21ba78b50397401d.map((instruction)=>[
        instruction.type,
        instruction
    ]));


function $89fca1fc34747a96$export$4e62c701997796c1(value) {
    return value !== null && value !== undefined;
}


class $f656bceb4fdb42be$export$26867f1d16acc301 {
    constructor(){
        this.gridDimensions = {
            width: 10,
            height: 10
        };
        this.reference = [];
        this.mana = 0;
        this.flux = 0;
        this.cursorIndex = 0;
        this.cursorDirection = "right";
        this.instructions = new Map();
        this.selectedPaletteInstruction = (0, $ed3bff3811882801$export$21ba78b50397401d)[0].type;
        (0, $32XxQ.makeAutoObservable)(this);
    }
    get cursorGridLocation() {
        return (0, $d198ee6d45780193$export$6da0b3c496770736).fromGridIndex(this.cursorIndex, this.gridDimensions);
    }
    step() {
        const location = (0, $d198ee6d45780193$export$6da0b3c496770736).fromGridIndex(this.cursorIndex, this.gridDimensions);
        const instruction = this.instructions.get(location.toHash());
        const instructionResult = instruction?.act(this);
        const shouldAdvanceCursor = !instructionResult || instructionResult.shouldAdvanceCursor;
        if (shouldAdvanceCursor) {
            const newIndex = (0, $3f1d9af7161661b8$export$6dddf77696535a87)(this.cursorIndex, this.cursorDirection, this.gridDimensions);
            this.cursorIndex = newIndex;
        }
    }
    getNeighboringInstructions(location) {
        return [
            location.addDirection("up"),
            location.addDirection("down"),
            location.addDirection("left"),
            location.addDirection("right")
        ].map((location)=>this.instructions.get(location.toHash())).filter((0, $89fca1fc34747a96$export$4e62c701997796c1));
    }
    getInstructionAtLocation(location) {
        return this.instructions.get(location.toHash());
    }
}
const $f656bceb4fdb42be$export$ee72801824c03e63 = new $f656bceb4fdb42be$export$26867f1d16acc301();
const $f656bceb4fdb42be$export$eb6fef7b613a504d = /*#__PURE__*/ (0, $exYeM.createContext)($f656bceb4fdb42be$export$ee72801824c03e63);
const $f656bceb4fdb42be$export$ee77be57e9c17060 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($f656bceb4fdb42be$export$eb6fef7b613a504d.Provider, {
        value: $f656bceb4fdb42be$export$ee72801824c03e63,
        children: children
    });
};
const $f656bceb4fdb42be$export$cf8b215f0a36143c = ()=>{
    const program = (0, $exYeM.useContext)($f656bceb4fdb42be$export$eb6fef7b613a504d);
    return program;
};
function $f656bceb4fdb42be$export$206216ed3259f087(WrappedComponent) {
    return function(props) {
        return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($f656bceb4fdb42be$export$ee77be57e9c17060, {
            children: /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)(WrappedComponent, {
                ...props
            })
        });
    };
}



var $32XxQ = parcelRequire("32XxQ");

var $exYeM = parcelRequire("exYeM");
if (!(0, $exYeM.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $32XxQ.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");






var $32XxQ = parcelRequire("32XxQ");
function $19d8cb9702f2543f$export$fb2daceae6f5097a(callback) {
    callback();
}
function $19d8cb9702f2543f$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $19d8cb9702f2543f$export$fb2daceae6f5097a;
    (0, $32XxQ.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $19d8cb9702f2543f$export$13ce1459b9a04b51 = function() {
    return true;
};


var $8774f540edb75659$var$deprecatedMessages = [];
function $8774f540edb75659$export$be38475be17599d(msg) {
    if (!$8774f540edb75659$var$deprecatedMessages.includes(msg)) {
        $8774f540edb75659$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $32XxQ = parcelRequire("32XxQ");

var $exYeM = parcelRequire("exYeM");

var $32XxQ = parcelRequire("32XxQ");
function $11eb22b7f00fc0db$export$ef795f1f307682c7(v) {
    return (0, $32XxQ.getDependencyTree)(v);
}


var $d1f77f86dc2d5ebe$var$globalIsUsingStaticRendering = false;
function $d1f77f86dc2d5ebe$export$5d52eaa7c0f24c9e(enable) {
    $d1f77f86dc2d5ebe$var$globalIsUsingStaticRendering = enable;
}
function $d1f77f86dc2d5ebe$export$55979271896d643e() {
    return $d1f77f86dc2d5ebe$var$globalIsUsingStaticRendering;
}


var $405c8a72dae1eaac$export$e901ba0ffe10ba41 = 10000;
var $405c8a72dae1eaac$export$1ae22ce5a82f26b6 = 10000;
var $405c8a72dae1eaac$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $405c8a72dae1eaac$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $405c8a72dae1eaac$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $405c8a72dae1eaac$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $405c8a72dae1eaac$export$b7a00d372cedeedd;


var $dccef8119a05045c$export$10e8a12fbfd8583c = new (0, $405c8a72dae1eaac$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $acc6e66c89a48fc4$exports = {};
"use strict";

$acc6e66c89a48fc4$exports = (parcelRequire("1nNjm"));


function $cc1494d0baf2bb6b$var$createReaction(adm) {
    adm.reaction = new (0, $32XxQ.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $cc1494d0baf2bb6b$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $d1f77f86dc2d5ebe$export$55979271896d643e)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $dccef8119a05045c$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $cc1494d0baf2bb6b$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $cc1494d0baf2bb6b$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $dccef8119a05045c$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($exYeM))).useDebugValue(adm.reaction, (0, $11eb22b7f00fc0db$export$ef795f1f307682c7));
    (0, $acc6e66c89a48fc4$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $exYeM = parcelRequire("exYeM");


var $d8435ca1ba808b6c$var$_a, $d8435ca1ba808b6c$var$_b;
var $d8435ca1ba808b6c$var$warnObserverOptionsDeprecated = true;
var $d8435ca1ba808b6c$var$warnLegacyContextTypes = true;
var $d8435ca1ba808b6c$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $d8435ca1ba808b6c$var$isFunctionNameConfigurable = ($d8435ca1ba808b6c$var$_b = ($d8435ca1ba808b6c$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $d8435ca1ba808b6c$var$_a === void 0 ? void 0 : $d8435ca1ba808b6c$var$_a.configurable) !== null && $d8435ca1ba808b6c$var$_b !== void 0 ? $d8435ca1ba808b6c$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $d8435ca1ba808b6c$var$ReactForwardRefSymbol = $d8435ca1ba808b6c$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $exYeM.forwardRef) === "function" && (0, $exYeM.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $d8435ca1ba808b6c$var$ReactMemoSymbol = $d8435ca1ba808b6c$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $exYeM.memo) === "function" && (0, $exYeM.memo)(function(props) {
    return null;
})["$$typeof"];
function $d8435ca1ba808b6c$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($d8435ca1ba808b6c$var$ReactMemoSymbol && baseComponent["$$typeof"] === $d8435ca1ba808b6c$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $d1f77f86dc2d5ebe$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($d8435ca1ba808b6c$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $d8435ca1ba808b6c$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $cc1494d0baf2bb6b$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($d8435ca1ba808b6c$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $exYeM.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $exYeM.memo)(observerComponent);
    $d8435ca1ba808b6c$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $d8435ca1ba808b6c$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $d8435ca1ba808b6c$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$d8435ca1ba808b6c$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $3b7213e263813e47$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $cc1494d0baf2bb6b$export$b9c7ecd090a87b14)(component);
}
$3b7213e263813e47$export$c1cbdee04e18ea8b.displayName = "Observer";
function $3b7213e263813e47$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $32XxQ = parcelRequire("32XxQ");

var $exYeM = parcelRequire("exYeM");
function $7687a074b523e33c$export$aa207039f277c5f(initializer, annotations) {
    return (0, $exYeM.useState)(function() {
        return (0, $32XxQ.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $32XxQ = parcelRequire("32XxQ");

var $exYeM = parcelRequire("exYeM");



var $32XxQ = parcelRequire("32XxQ");

var $exYeM = parcelRequire("exYeM");
function $65de1299737942b3$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $exYeM.useState)(function() {
        return (0, $32XxQ.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $32XxQ.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $77abb97e42371bd7$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $65de1299737942b3$export$e0ded3646391939c)(current);
    return (0, $exYeM.useState)(function() {
        return (0, $32XxQ.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $cd6d738f21c3fd56$var$_a;
(0, $19d8cb9702f2543f$export$294943bbc3c74f4f)((0, $97dc602bd7e23afa$exports.unstable_batchedUpdates));
var $cd6d738f21c3fd56$export$469d51fb8d268227 = ($cd6d738f21c3fd56$var$_a = (0, $dccef8119a05045c$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $cd6d738f21c3fd56$var$_a !== void 0 ? $cd6d738f21c3fd56$var$_a : function() {};
function $cd6d738f21c3fd56$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $cc1494d0baf2bb6b$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $cd6d738f21c3fd56$export$7613124ee4202834(enable) {
    (0, $d1f77f86dc2d5ebe$export$5d52eaa7c0f24c9e)(enable);
}




parcelRequire("exYeM");



const $86c2911d9dd331b7$export$e2fbaa661ec19dbf = (0, $d8435ca1ba808b6c$export$b6ae1bc530f4c149)(function Palette() {
    const program = (0, $f656bceb4fdb42be$export$cf8b215f0a36143c)();
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                children: "Palette"
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column"
                },
                children: (0, $ed3bff3811882801$export$21ba78b50397401d).map((instruction)=>{
                    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                        style: {
                            width: `${(0, $86c1020597e9be8a$export$b6ba90e55ec79c0b)}px`,
                            height: `${(0, $86c1020597e9be8a$export$b6ba90e55ec79c0b)}px`,
                            border: program.selectedPaletteInstruction === instruction.type ? "1px solid black" : "1px solid transparent",
                            cursor: "pointer"
                        },
                        onClick: ()=>program.selectedPaletteInstruction = instruction.type,
                        children: instruction.toString()
                    }, instruction.type);
                })
            })
        ]
    });
});




var $exYeM = parcelRequire("exYeM");




parcelRequire("exYeM");

function $5570209550101bad$export$7f1ebd623f131021(length, creator) {
    return new Array(length).fill(0).map((_, index)=>creator(index));
}



const $ac0242369dfc750a$export$ef2184bd89960b14 = (0, $d8435ca1ba808b6c$export$b6ae1bc530f4c149)(function Grid({ dimensions: dimensions, renderCell: renderCell }) {
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: `${0, $86c1020597e9be8a$export$b6ba90e55ec79c0b}px `.repeat(dimensions.width)
        },
        children: (0, $5570209550101bad$export$7f1ebd623f131021)(dimensions.height * dimensions.width, (index)=>renderCell(index))
    });
});




const $4fe753f9efcb35f3$export$277a57887e565a09 = (0, $d8435ca1ba808b6c$export$b6ae1bc530f4c149)(function Workspace() {
    const [isCasting, setIsCasting] = (0, $exYeM.useState)(false);
    const program = (0, $f656bceb4fdb42be$export$cf8b215f0a36143c)();
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    gap: (0, $86c1020597e9be8a$export$b6ba90e55ec79c0b) / 2,
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                        children: "Workspace"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        onClick: ()=>{
                            setIsCasting(!isCasting);
                        },
                        style: {
                            height: "fit-content",
                            cursor: "pointer"
                        },
                        children: isCasting ? "Abort" : "Cast"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("button", {
                        onClick: ()=>program.step(),
                        style: {
                            height: "fit-content",
                            cursor: "pointer"
                        },
                        children: "Step"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $ac0242369dfc750a$export$ef2184bd89960b14), {
                dimensions: program.gridDimensions,
                renderCell: (index)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        style: {
                            width: `${(0, $86c1020597e9be8a$export$b6ba90e55ec79c0b)}px`,
                            height: `${(0, $86c1020597e9be8a$export$b6ba90e55ec79c0b)}px`,
                            border: program.cursorIndex === index ? "1px solid black" : "1px solid transparent"
                        },
                        onClick: ()=>{
                            const location = (0, $d198ee6d45780193$export$6da0b3c496770736).fromGridIndex(index, program.gridDimensions);
                            program.instructions.set(location.toHash(), (0, $ed3bff3811882801$export$f6f75c26df0cd6a0)[program.selectedPaletteInstruction]);
                        },
                        children: [
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                children: index
                            }),
                            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("div", {
                                children: program.instructions.get((0, $d198ee6d45780193$export$6da0b3c496770736).fromGridIndex(index, program.gridDimensions).toHash())?.type
                            })
                        ]
                    }, index)
            })
        ]
    });
});


const $7d0d880cf2ba634e$var$App = (0, $d8435ca1ba808b6c$export$b6ae1bc530f4c149)(()=>{
    const program = (0, $f656bceb4fdb42be$export$cf8b215f0a36143c)();
    return /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("main", {
        style: {
            display: "flex",
            gap: (0, $86c1020597e9be8a$export$b6ba90e55ec79c0b)
        },
        children: [
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $86c2911d9dd331b7$export$e2fbaa661ec19dbf), {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)((0, $4fe753f9efcb35f3$export$277a57887e565a09), {}),
            /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("h2", {
                        children: "Evaluation"
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        children: [
                            "Mana: ",
                            program.mana
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsxs)("div", {
                        children: [
                            "Flux: ",
                            program.flux
                        ]
                    }),
                    /*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("ul", {
                        children: program.reference.map((item, index)=>/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)("li", {
                                children: item
                            }, item + "." + index))
                    })
                ]
            })
        ]
    });
});
const $7d0d880cf2ba634e$var$AppWithProgram = (0, $f656bceb4fdb42be$export$206216ed3259f087)($7d0d880cf2ba634e$var$App);
const $7d0d880cf2ba634e$var$container = document.getElementById("root");
if (!$7d0d880cf2ba634e$var$container) throw new Error("Root container missing in index.html");
const $7d0d880cf2ba634e$var$root = (0, $7bd215913159ea08$export$882461b6382ed46c)($7d0d880cf2ba634e$var$container);
$7d0d880cf2ba634e$var$root.render(/*#__PURE__*/ (0, $7ead0b1397a835ed$exports.jsx)($7d0d880cf2ba634e$var$AppWithProgram, {}));

})();
//# sourceMappingURL=index.3eb7f78c.js.map
